import React, { Suspense, useEffect, useState,useRef,useContext } from "react";
import { Link,useNavigate } from 'react-router-dom';
import { RiDashboardLine, RiUser4Line, RiUser3Line, RiLinkedinFill, RiBuilding4Line, RiBuilding2Line, RiContactsBook2Line, RiHomeHeartLine, RiUserUnfollowLine, RiLogoutCircleRLine, RiEditLine, RiCloseLargeFill, RiDeleteBin7Line } from "react-icons/ri";
import { BsBuildingUp, BsBuildingCheck, BsBuildingExclamation } from "react-icons/bs";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import OwlCarousel from "react-owl-carousel3";
import { GoChevronRight, GoChevronLeft } from "react-icons/go";
import PropertyBox from "../home/propertyBox";
import { RiShareForwardLine, RiUserLocationLine, RiDeleteBin6Line } from "react-icons/ri";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { GrUserWorker, GrLocation } from "react-icons/gr";
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsEmojiSmile, BsEmojiSunglasses, BsEmojiSurprise, BsEmojiTear } from "react-icons/bs";
import { LuLayoutTemplate } from "react-icons/lu";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";
import { BiLogoFacebook } from "react-icons/bi";
import { PiPhoneCall, PiInstagramLogoFill, PiYoutubeLogoFill } from "react-icons/pi";
import { MdAlternateEmail, MdAdd, MdRemove, MdWhatsapp } from "react-icons/md";
import { RoleContext } from '../../pages/Userdatacontext/Datacontexts';
import { FiArrowUpRight, FiCopy } from "react-icons/fi";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import CustomSingleSelectDropdown from "../../widgets/dropdown/CustomSingleSelectDropdown";
import { LoginPopupContext } from '../../loginpopup/LoginPopupContext';

import countBg1 from '../../../assets/images/icon/bg1.png'
import countBg2 from '../../../assets/images/icon/bg2.png'
import countBg3 from '../../../assets/images/icon/bg3.png'
import countBg4 from '../../../assets/images/icon/bg4.png'
import myPropertyImg1 from '../../../assets/images/property/img1.jpg'
import myPropertyImg2 from '../../../assets/images/property/img2.jpg'
import myPropertyImg3 from '../../../assets/images/property/img3.jpg'
import myPropertyImg4 from '../../../assets/images/property/img4.jpg'
import myPropertyImg5 from '../../../assets/images/property/img5.jpg'
import myPropertyImg6 from '../../../assets/images/property/img6.jpg'
import myPropertyImg7 from '../../../assets/images/property/img7.jpg'
import myPropertyImg8 from '../../../assets/images/property/img8.jpg'
import emptyVideo from '../../../assets/images/empty.mp4'
import shareVideo from '../../../assets/images/share.mp4'
import projectImg1 from '../../../assets/images/builders/builderProjects/img1.webp'
import projectImg2 from '../../../assets/images/builders/builderProjects/img2.webp'
import projectImg3 from '../../../assets/images/builders/builderProjects/img3.webp'
import projectImg4 from '../../../assets/images/builders/builderProjects/img4.webp'
import projectImg5 from '../../../assets/images/builders/builderProjects/img5.webp'
import projectImg6 from '../../../assets/images/builders/builderProjects/img6.webp'
import projectImg7 from '../../../assets/images/builders/builderProjects/img7.webp'
import projectImg8 from '../../../assets/images/builders/builderProjects/img8.webp'
import fileImg from '../../../assets/images/fileImg.jpg'
import axios from 'axios';
import { mediaUrl,baseURL } from '../../axiosInterceptor/axiosInterceptorC';
import { useDispatch, useSelector } from "react-redux";
import { fetchUserDetails,fetchPropertyDetails,resetUserState } from '../../slice/userSlice';
import { fetchmyPropertyDetails } from "../../slice/MyPropertiesSlice";
const path = "/keralaplots/";

function MyProfile() {
    const popupRef = useRef(null);
    const dispatch = useDispatch();

    const { updateRole ,gettokenval,settokenval} = useContext(RoleContext);
    const { fetchpropertydetails } = useContext(RoleContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (!gettokenval) {
            navigate(path);
        }
    }, [gettokenval, navigate]);

    const handleScrollToTop = () => {
        popupRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    };

    const [formData, setFormData] = useState({
        phone: "",
        otp: "",
        projectName: "",
        phoneNumber: "",
        optionalPhoneNumber: "",
        projectDetails: "",
        locationName:"",

    });
    const [formData2, setFormData2] = useState({
        phone2: "",
        otp2: "",
    });
    const [phoneNumbers, setPhoneNumbers] = useState([]); // Initial number
    // skelly loader
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingcontacted,setisLoadingcontacted]= useState(true);
    const [isLoadingsaved,setisLoadingsaved]= useState(true);

    // role switch
    const [selectedRole, setSelectedRole] = useState();
    const [name, setName] = useState();
    // const [pNumber, setPNumber] = useState("7356339750");
    const [isNameEditPopupVisible, setIsNameEditPopupVisible] = useState(false);
    const [isNumberEditPopupVisible, setIsNumberEditPopupVisible] = useState(false);
    const [isNumberEditPopupVisiblealter, setIsNumberEditPopupVisiblealter] = useState(false);
    const [isNumberAddPopupVisible, setIsNumberAddPopupVisible] = useState(false);
    const [isNumberTemplateVisible, setIsNumberTemplateVisible] = useState(false);
    const [showOtpInput, setShowOtpInput] = useState(false);
    const [generatedOtp, setGeneratedOtp] = useState(null); // To hold the generated OTP
    const [showOtpGroup, setShowOtpGroup] = useState(false);
    const [isTimerRunning, setIsTimerRunning] = useState(false);
    const [timer, setTimer] = useState(60);
    const [showResendBtn, setShowResendBtn] = useState(false);
    const [isFormBtnEnabled, setIsFormBtnEnabled] = useState(false);
    const [isSettingPopupVisible, setIsSettingPopupVisible] = useState(false);
    const [isDeletePopupVisible, setIsDeletePopupVisible] = useState(false);
    const [isDeactivatePopupVisible, setIsDeactivatePopupVisible] = useState(false);
    const [isProjectUploadPopupVisible, setIsProjectUploadPopupVisible] = useState(false);
    const [logoImages, setLogoImages] = useState([]);
    const [projectLogoImages, setProjectLogoImages] = useState([]);
    const [bannerImages, setBannerImages] = useState([]);
    const [projectBannerImages, setProjectBannerImages] = useState([]);
    const [about, setAbout] = useState({ title: '', description: '', experience: '' });
    const [savedP, setsavedP] = useState([]);
    // const [companyName, setCompanyName] = useState({ name: '' });
    const [testimonials, setTestimonials] = useState([]);
    const [galleryImages, setGalleryImages] = useState([]);
    const [contact, setContact] = useState({ phone: '', email: '' });
    const [testimonialerror, settestimonialerror] = useState('');
    const [previewMode, setPreviewMode] = useState(false);
    const [isProfileMenuActive, setIsProfileMenuActive] = useState(false);
    const [isShimmerVisible, setIsShimmerVisible] = useState(false);
    const Property_url="https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/";
    const BASE_URL = "https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/";
    const BASE_URL_NOIMG = "https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/nophoto.webp";
    const [townList, setTownList] = useState([]);

    const [companyName, setCompanyName] = useState('');
    const handleCompanyNameChange = (event) => {
        const name = event.target.value.trimStart(); // Prevent leading spaces
        setCompanyName(name);

        if (!name ) {
            SetCompanyError((prev) => ({ ...prev, name: 'Company name is required' }));
        } else {
            if(name.includes("'")){
                SetCompanyError((prev) => ({ ...prev, name: "Ensure the company name does not contain a single quote (')" }));
            }
            else{
                SetCompanyError((prev) => ({ ...prev, name: '' }));
            }
        }


        // Validate logo section
        if (!name || logoImages.length === 0) {
            SetwebsitelogocompError('Please fill the logo section.');
        } else {
            SetwebsitelogocompError('');
        }
    };

    useEffect(() => {
        // setTimeout(() => {
            const timeout = setTimeout(() => setIsLoading(false), 0);
            return () => clearTimeout(timeout);
        // }, 100000);
    }, []);

    // role switch
    const handleRoleChange = (e) => {
        setSelectedRole(e.target.id);
        if(e.target.id=="Agent"){
            toast.success("Profile Changed to Agent!");
        }
        if(e.target.id=="user"){
            toast.success("Profile Changed to User!");
        }
        if(e.target.id=="Builder"){
            toast.success("Profile Changed to Builder!");
        }
    };
    
    // name edit
    const handleNameChange = (e) => {
        setName(e.target.value); // Update the state when the input changes
    };

    const handleNameSubmit = async(e) => {
        e.preventDefault(); // Prevent form submission refresh
        if (name.trim() === "") {
            toast.error("Name cannot be empty!"); // Show error if the name is empty
        } else {

    const submissionData = new FormData();
    const login_id = localStorage.getItem('login_id');
    submissionData.append("login_id", login_id);
    submissionData.append("phone_number_val", Logphonenum);
    submissionData.append("name_val", name);
    submissionData.append("role_val", selectedRole);
    submissionData.append("district_val", selectedDistrict);
    submissionData.append("town_val", selectedTown);
    submissionData.append("experiance_val", formplaceData.experiance_val);
    submissionData.append("alternative_number_arr", JSON.stringify(phoneNumbers));
    try {
        const response = await axios.post(`${baseURL}/editprofiledetails`, submissionData, {
            headers: { "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            localStorage.setItem('roleval', selectedRole);
            updateRole(selectedRole);
            dispatch(fetchUserDetails(login_id));
            toast.success("Name updated successfully!"); // Show success message
            setIsNameEditPopupVisible(false);
            document.body.style.overflow = 'inherit';
        }
    }catch (error) { 
        const errorMessage = error.response?.data?.message || error.message || "Failed to upload project.";
        console.error("Error occurred during project upload:", errorMessage);
        toast.error(errorMessage);
         
    }finally {

    } 

        }
    };
    const handleEditNameClick = () => {
        setIsNameEditPopupVisible(true);
        document.body.style.overflow = 'hidden';
    };

    const handlePhoneChangealter = (e) => {
        const { name, value } = e.target;
        setSelectedPhoneNumber(value)
    };

    // Handle phone input (only numbers)
    const handlePhoneChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*$/.test(value)) {
            setFormData({ ...formData, [name]: value });
        }
    };
    const handlePhoneChange2 = (e) => {
        const { name, value } = e.target;
        if (/^\d*$/.test(value)) {
            setFormData2({ ...formData2, [name]: value });
        }
    };
    const handleEditNumberClick = () => {
        setIsNumberEditPopupVisible(true);
        document.body.style.overflow = 'hidden';
    };

    const [selectedPhoneNumber, setSelectedPhoneNumber] = useState("");
    const [editAlternumberid, seteditAlternumberid] = useState("");

    const handleEditNumberClickalter = (number,id) => {
       seteditAlternumberid(id)
        setSelectedPhoneNumber(number)
        setIsNumberEditPopupVisiblealter(true);
        document.body.style.overflow = 'hidden';
    };

    const handleAddNumberClick = () => {
        setIsNumberAddPopupVisible(true);
        document.body.style.overflow = 'hidden';
    };

    // Hide the popup
    const handleCloseClick = () => {
        setIsNameEditPopupVisible(false);
        setIsNumberEditPopupVisible(false);
        setIsNumberEditPopupVisiblealter(false)
        setIsNumberAddPopupVisible(false);
        setIsSettingPopupVisible(false);
        setIsDeletePopupVisible(false);
        setIsDeactivatePopupVisible(false);
        setIsProjectDeletePopupVisible(false);
        setDeleteProjectId(null);
        setIsProjectUploadPopupVisible(false);
        document.body.style.overflow = 'inherit';
        setContent('');
        setProjectStatus('');
        setLogoError('');
        SetbannerlogoError('');
        setProjectLogoImages([]);
        setProjectBannerImages([]);
        setUploadedFiles([]);
        // setFormData({
        //     projectName: '',
        //     phoneNumber: '',
        //     optionalPhoneNumber: '',
        //     locationName:'',
        // });
    };

    // Generate and send OTP
    const handleGetOtp = () => {
        console.log(formData.phone)
        if (!formData.phone || formData.phone.length < 10) {
            toast.error("Please enter a valid phone number.");
            return;
        }
        
        const otp = Math.floor(100000 + Math.random() * 900000); // Generate 6-digit OTP
        setGeneratedOtp(otp);
        toast.success(`OTP has been sent to your phone`); // Mocked OTP for testing
        send_otp_function(formData.phone,otp)
        //console.log(otp)
        setShowOtpGroup(true);
        setShowOtpInput(true);
        setIsTimerRunning(true);
        setTimer(60);
        setShowResendBtn(false);
        setIsFormBtnEnabled(false);
    };

    const handleGetOtpalter = async() => {
        setphonnumberalterexisterr("")
        if (selectedPhoneNumber.length< 10) {
            toast.error("Please enter a valid phone number.");
            return;
        }
        
        try {
            const response=await axios.post(`${baseURL}/check_alter_number_exist`,{
                id:editAlternumberid,
                phone_number:selectedPhoneNumber,
            })
            console.log(response.status)
            if(response.status==201){
                setphonnumberalterexisterr("Phone number already exist")
            }
            else{
                const otp = Math.floor(100000 + Math.random() * 900000); // Generate 6-digit OTP
                setGeneratedOtp(otp);
                toast.success(`OTP has been sent to your phone`); // Mocked OTP for testing
                send_otp_function(selectedPhoneNumber,otp)
                //console.log(otp)
                setShowOtpGroup(true);
                setShowOtpInput(true);
                setIsTimerRunning(true);
                setTimer(60);
                setShowResendBtn(false);
                setIsFormBtnEnabled(false);
            }
        }
        catch{

        }
        
    };

    // Generate and send OTP
    const handleGetOtp2 = async () => {
        setphonnumberalterexisterr("");
    
        if (!formData2.phone2 || formData2.phone2.length < 10) {
            toast.error("Please enter a valid phone number.");
            return;
        }
    
        try {
            const response = await axios.post(`${baseURL}/check_alter_number_exist`, {
                id: editAlternumberid,
                phone_number: formData2.phone2, // Fix: Use the new number entered by the user
            });
    
            console.log(response.status);
    
            if (response.status === 201) {
                setphonnumberalterexisterr("Phone number already exists");
                return; // Stop execution if the number exists
            }
    
            // If phone number is not in use, generate OTP
            const otp = Math.floor(100000 + Math.random() * 900000); // Generate a 6-digit OTP
            setGeneratedOtp(otp);
            toast.success(`OTP has been sent to your phone`); // Mocked OTP for testing
    
            // Uncomment this when you have the actual OTP function
             send_otp_function(formData2.phone2, otp);
    
            // Show OTP input fields and start the timer
            setShowOtpGroup(true);
            setShowOtpInput(true);
            setIsTimerRunning(true);
            setTimer(60);
            setShowResendBtn(false);
            setIsFormBtnEnabled(false);
        } catch (error) {
            console.error("Error checking phone number:", error);
            toast.error("Something went wrong. Please try again.");
        }
    };
    

    const send_otp_function=async(phone_number,otp_val)=>{
        try {
            const response=await axios.post(`${baseURL}/send_otp_function`,{
                phone_number:phone_number,
                otp_val:otp_val
            })
            //console.log(response.data)
        } catch (error) {
            
        }
    }

    // Handle OTP input and enable form button
    const handleOtpChange = (e) => {
        const otp = e.target.value;
        if (/^\d*$/.test(otp) && otp.length <= 6) {
            setFormData({ ...formData, otp });
            setIsFormBtnEnabled(otp.length === 6);
        }
    };

    // Handle OTP input and enable form button
    const handleOtpChange2 = (e) => {
        const otp = e.target.value;
        if (/^\d*$/.test(otp) && otp.length <= 6) {
            setFormData2({ ...formData2, otp2: otp }); // Update otp2
            setIsFormBtnEnabled(otp.length === 6); // Enable button only if OTP has 6 digits
        }
    };

    const handleOtpChangealter = (e) => {
        const otp = e.target.value;
        if (/^\d*$/.test(otp) && otp.length <= 6) {
            setFormData({ ...formData, otp });
            setIsFormBtnEnabled(otp.length === 6);
        }
    };

    // Resend OTP logic
    const handleResendOtp = () => {
        const otp = Math.floor(100000 + Math.random() * 900000); // Generate new OTP
        setGeneratedOtp(otp);
        toast.info(`Resented OTP to your phone`); // Mocked OTP for testing
        send_otp_function(formData.phone,otp)
        //console.log(otp)
        setTimer(60);
        setIsTimerRunning(true);
        setShowResendBtn(false);
    };

    const handleResendOtpalter = () => {
        const otp = Math.floor(100000 + Math.random() * 900000); // Generate new OTP
        setGeneratedOtp(otp);
        toast.info(`Resented OTP to your phone`); // Mocked OTP for testing
        send_otp_function(selectedPhoneNumber,otp)
        //console.log(otp)
        setTimer(60);
        setIsTimerRunning(true);
        setShowResendBtn(false);
    };

    // Timer countdown effect
    useEffect(() => {
        let countdown;
        if (isTimerRunning) {
            countdown = setInterval(() => {
                setTimer((prev) => {
                    if (prev <= 1) {
                        clearInterval(countdown);
                        setIsTimerRunning(false);
                        setShowResendBtn(true);
                        setGeneratedOtp(null); // Invalidate OTP
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
        return () => clearInterval(countdown);
    }, [isTimerRunning]);

    // Handle OTP submission
    const handleOtpSubmit = async() => {
        if (!generatedOtp) {
            toast.error("OTP has expired. Please resend OTP.");
            return;
        }
        if (formData.otp === generatedOtp?.toString()) {
            setLogphonenum(formData.phone)
            toast.success("OTP validation successful! Your phone number Updated"); // Success message
            setFormData({
                otp: "",
            });
            setShowOtpInput(false);
            setShowOtpGroup(false);
            setIsTimerRunning(false);
            setTimer(60);
            setShowResendBtn(false);
            setGeneratedOtp(null);
            setIsFormBtnEnabled(false);
            setIsNumberEditPopupVisible(false);
            document.body.style.overflow = 'inherit';


            const submissionData = new FormData();
    const login_id = localStorage.getItem('login_id');
    submissionData.append("login_id", login_id);
    submissionData.append("phone_number_val", formData.phone);
    submissionData.append("name_val", name);
    submissionData.append("role_val", selectedRole);
    submissionData.append("district_val", selectedDistrict);
    submissionData.append("town_val", selectedTown);
    submissionData.append("experiance_val", formplaceData.experiance_val);
    submissionData.append("alternative_number_arr", JSON.stringify(phoneNumbers));
    try {
        const response = await axios.post(`${baseURL}/editprofiledetails`, submissionData, {
            headers: { "Content-Type": "application/json" },
        });
        console.log(response.status)
        if (response?.status === 200) {
            localStorage.setItem('roleval', selectedRole);
            updateRole(selectedRole);
            dispatch(fetchUserDetails(login_id));
        }
    }catch (error) { 
        const errorMessage = error.response?.data?.message || error.message || "Failed to upload project.";
        console.error("Error occurred during project upload:", errorMessage);
        toast.error(errorMessage);
         
    }finally {

    } 

        } else {
            toast.error("Invalid OTP. Please try again."); // Error message
        }
    };

    // Handle OTP submission
    const handleOtpSubmit2 = async() => {
        if (!generatedOtp) {
            toast.error("OTP has expired. Please resend OTP.");
            return;
        }
        if (formData2.otp2 === generatedOtp?.toString()) {
            const newPhone = {
                id: Date.now(), // Temporary unique ID (replace with actual ID from DB after API call)
                phone_number: formData2.phone2.toString(),
            };
            // Append the new phone number to the list
            setphoneNumberget((prev) => [...prev, newPhone]);
    

          const login_id=localStorage.getItem('login_id')
            try {
                const response=await axios.post(`${baseURL}/add_alter_phone_number`,{
                    login_id:login_id,
                    phone_number:formData2.phone2,
                })
                console.log(response.status)
                if(response.status==200){
                    dispatch(fetchUserDetails(login_id));
                    toast.success("OTP validation successful! New phone number added.");
                    setFormData2({ phone2: "", otp2: "" });
                    setShowOtpInput(false);
                    setShowOtpGroup(false);
                    setIsTimerRunning(false);
                    setTimer(60);
                    setShowResendBtn(false);
                    setGeneratedOtp(null);
                    setIsFormBtnEnabled(false);
                    setIsNumberAddPopupVisible(false);
                    setIsNumberTemplateVisible(true); // Make new numbers visible
                    document.body.style.overflow = 'inherit';
                }
            }
            catch{
                
            }
            // Reset form states
        } else {
            toast.error("Invalid OTP. Please try again.");
        }
    };

    const [phonnumberalterexisterr,setphonnumberalterexisterr]=useState('')

    const handleOtpSubmitalter = async() => {
        setphonnumberalterexisterr("")
        if (!generatedOtp) {
            toast.error("OTP has expired. Please resend OTP.");
            return;
        }
        if (formData.otp === generatedOtp?.toString()) {  
            
            const login_id = localStorage.getItem('login_id');
            try {
                const response=await axios.post(`${baseURL}/editalternatinvenumber`,{
                    id:editAlternumberid,
                    phone_number:selectedPhoneNumber,
                })
                console.log(response.status)
                if(response.status==200){
                    dispatch(fetchUserDetails(login_id));

                    toast.success("OTP validation successful!  phone number edited.");
            
                    // Reset form states
                    setFormData2({ phone2: "", otp2: "" });
                    setShowOtpInput(false);
                    setShowOtpGroup(false);
                    setIsTimerRunning(false);
                    setTimer(60);
                    setShowResendBtn(false);
                    setGeneratedOtp(null);
                    setIsFormBtnEnabled(false);
                    setIsNumberAddPopupVisible(false);
                    setIsNumberTemplateVisible(true); // Make new numbers visible
                    setIsNumberEditPopupVisiblealter(false)
                    document.body.style.overflow = 'inherit';

                }
                else{
                    setphonnumberalterexisterr("Phone number already exist")
                }
                 
            } catch (error) {
                
            }
            
        } else {
            toast.error("Invalid OTP. Please try again.");
        }
    };

    const handleDeleteNumberClick = async(index,id) => {
        setphoneNumberget((prev) => prev.filter((_, i) => i !== index));
        toast.success("Phone number deleted.");
        const login_id = localStorage.getItem('login_id');
            try {
                const response=await axios.post(`${baseURL}/deletealternatinvenumber`,{
                    id:id,
                })
                console.log(response.status)
                if(response.status==200){
                    dispatch(fetchUserDetails(login_id));
                }
            }
        catch{

        }
    };

    useEffect(() => {
        if (isSettingPopupVisible) {
            document.body.style.overflow = 'hidden'; // Hide overflow when sidemenu is active
        } else {
            document.body.style.overflow = 'inherit'; // Restore original overflow when sidemenu is closed
        }
    }, [isSettingPopupVisible]);

    // deletPropertyClick
    const deletPropertyClick = () => {
        setIsDeletePopupVisible(true);
        setIsSettingPopupVisible(false);
    }
    useEffect(() => {
        if (isDeletePopupVisible) {
            document.body.style.overflow = 'hidden'; // Hide overflow when sidemenu is active
        } else {
            document.body.style.overflow = 'inherit'; // Restore original overflow when sidemenu is closed
        }
    }, [isDeletePopupVisible]);

    const submitDeleteClick = () => {
        setIsDeletePopupVisible(false);
        toast.success("Property deleted.");
        propertydeletedata(0)
    }

    const propertydeletedata = async (p_status) => {
        try {
        const response = await axios.post(`${baseURL}/propertydeletedata`, {
            property_id: SelectedPropertyId,
            p_status:p_status,
        });
        const login_id=localStorage.getItem('login_id')
        dispatch(fetchPropertyDetails({ login_id, Pstatus: p_status }));
        dispatch(fetchmyPropertyDetails(propertyclickval));
    }   
    catch (error) {
        console.error(error);
    }
}

    // addtoSoldClick
    const addtoSoldClick = () => {
        setIsSettingPopupVisible(false);
        toast.success("Property successfully added to sold.");
        setPropertystatus(2)
    }

    // movetoInactiveClick
    const movetoInactiveClick = () => {
        setIsSettingPopupVisible(false);
        toast.success("Property successfully Inactived.");
        setPropertystatus(3)

    }

    // submitDeactivateClick    
    const submitDeactivateClick = () => {
        setIsDeactivatePopupVisible(false);
        toast.success("Account deactivated.");
    }

    // deactivateAccountClick
    const deactivateAccountClick = () => {
        setIsDeactivatePopupVisible(true);
        setIsProfileMenuActive((prev) => !prev); // Toggle filter section
        document.body.style.overflow = 'inherit'; // Hide overflow when sidemenu is active
        setIsShimmerVisible(false);
    }


    const setPropertystatus = async (p_status) => {
        try {
        const response = await axios.post(`${baseURL}/setPropertystatus`, {
            property_id: SelectedPropertyId,
            p_status:p_status,
        });
        const login_id=localStorage.getItem('login_id')
        dispatch(fetchPropertyDetails({ login_id, Pstatus: p_status }));
        dispatch(fetchmyPropertyDetails(propertyclickval));
    }
    catch (error) {
        console.error(error);
    }
}

    const handleLogoDrop = (e) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);
        handleLogoUpload(files);
    };
    
    const removeLogoImage = (index) => {
        setLogoImages(logoImages.filter((_, i) => i !== index));
    };

    const handleBannerDrop = (e) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);
        handleBannerUpload(files);
    };
    
    
    const handleGalleryUpload = (files) => {
        if (galleryImages.length + files.length <= 16) {
            const newImages = files.map((file) => ({
                url: URL.createObjectURL(file),
                isNew: true, // Mark these images as new
            }));
    
            // Use functional update to get the latest state
            setGalleryImages((prevBannerImages) => [
                ...prevBannerImages,
                ...newImages
            ]);
        } else {
            alert('Maximum 16 banner images allowed!');
        }
    };

    const handleGalleryDrop = (e) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);
        handleGalleryUpload(files);
    };
    
    
    const handleAddTestimonial = () => {
        setTestimonials([...testimonials, { message: '', name: '' ,testimonial_status:'new'}]);
    };
    
    const handleTestimonialChange = (index, field, value) => {
        const updatedTestimonials = testimonials.map((testimonial, i) =>
          i === index ? { ...testimonial, [field]: value } : testimonial
        );
        setTestimonials(updatedTestimonials);
    };

    // projects
    // const [projects, setProjects] = useState([
    //     { id: 1, name: "Asset Vismayam", img: projectImg1, checked: false },
    //     { id: 2, name: "Asset The Leaf", img: projectImg2, checked: false },
    //     { id: 3, name: "Asset Taurus Identity", img: projectImg3, checked: false },
    //     { id: 4, name: "Asset Conzara", img: projectImg4, checked: false },
    //     { id: 5, name: "Asset Sunny Days", img: projectImg5, checked: false },
    //     { id: 6, name: "Asset Sovereign", img: projectImg6, checked: false },
    //     { id: 7, name: "Asset Legacy", img: projectImg7, checked: false },
    //     { id: 8, name: "Asset Orchestra", img: projectImg8, checked: false },
    // ]);

    const [projects, setProjects]=useState([])
    const [checkedProjectid, setProjectsid]=useState([])
    const [WebsiteProjectdeatils,setWebsiteProjectdeatils]=useState([]);

    const handleProjectCheck = (id) => {
        setProjects((prevProjects) =>
          prevProjects.map((project) =>
            project.id === id ? { ...project, checked: !project.checked } : project
          )
        );

        setWebsiteProjectdeatils((prevProjects) =>
            prevProjects.map((project) =>
              project.id === id ? { ...project, checked: !project.checked } : project
            )
          );

      setProjectsid((prevProjectsId) => {
        if (prevProjectsId.includes(id)) {
          return prevProjectsId.filter((projectId) => projectId !== id);
        } else {
          return [...prevProjectsId, id];
        }
      });
    };

    useEffect(() => {
      }, [checkedProjectid]);

    // property
    // const [properties, setProperties] = useState([
    //     { id: 1, name: "Commercial Land for sale in Palakkad", img: myPropertyImg1, checked: false },
    //     { id: 2, name: "Residential Land for sale in Ernakulam", img: myPropertyImg2, checked: false },
    //     { id: 3, name: "Residential Land for sale in Ernakulam", img: myPropertyImg3, checked: false },
    //     { id: 4, name: "Residential Villa for sale in Thrissur", img: myPropertyImg4, checked: false },
    //     { id: 5, name: "Residential Land for sale in Thrissur", img: myPropertyImg5, checked: false },
    //     { id: 6, name: "Residential Apartment for rent in Ernakulam", img: myPropertyImg7, checked: false },
    //     { id: 7, name: "Residential Land for sale in Idukki", img: myPropertyImg8, checked: false },
    //     { id: 8, name: "Residential Villa for sale in Thrissur", img: myPropertyImg8, checked: false },
    // ]);

    const [PropertiesId,setPropertiesId]=useState([])
    
    const handlePropertyCheck = (id) => {
        setProperties((prevProperties) => {
          const updatedProperties = prevProperties.map((property) =>
            property.propertyId === id ? { ...property, checked: !property.checked } : property
          );
          return updatedProperties;
        });
      
        setPropertiesId((prevPropertiesId) => {
          const updatedIds = prevPropertiesId.includes(id)
            ? prevPropertiesId.filter((propertyId) => propertyId !== id)
            : [...prevPropertiesId, id];
          return updatedIds;
        });
      };
      
      
    

    // projects
    const [isProjectDeletePopupVisible, setIsProjectDeletePopupVisible] = useState(false);

    const [projects2, setProjects2] = useState([])
    const [deleteProjectId, setDeleteProjectId] = useState(null);
    const [deletetype,setdeletetype]= useState(null);
    const [indexvaldelete,setIsindexvaldelete]=useState('');

    //delete projects
    const handleDeleteClick = (id) => {
        setDeleteProjectId(id);
        setdeletetype('projects')
        setIsProjectDeletePopupVisible(true);
    };
  
    //delete banner images
    const removeProjectBannerImage = async (index, id) => {
        setdeletetype('projectbanner')
        setDeleteProjectId(id);
        setIsProjectDeletePopupVisible(true);
        setIsindexvaldelete(index)
    };

    //delete website banner images
    const removeBannerImage = async (index,id) => {
        setdeletetype('websitebanner')
        setDeleteProjectId(id);
        setIsProjectDeletePopupVisible(true);
        setIsindexvaldelete(index)
    };

    //delete testimonial
    const removeTestimonial = (index,id) => {
        setdeletetype('websitetestimonial')
        setDeleteProjectId(id);
        setIsProjectDeletePopupVisible(true);
        setIsindexvaldelete(index)
    };

    //delete website gallery
    const removeGalleryImage = (index,id) => {
        setdeletetype('websitegallery')
        setDeleteProjectId(id);
        setIsProjectDeletePopupVisible(true);
        setIsindexvaldelete(index)
    };
    //final submission
    const submitProjectDeleteClick = async () => {
        if(deletetype=='projects'){
        try {
            // Make API call to delete the image
            const response = await axios.post(`${baseURL}/builder/deletebuilderProject`, {
                id: deleteProjectId,
            });

        } catch (error) {
            console.error('Error deleting banner image:', error);
        }

        toast.success("Project deleted successfully!");
        setProjects2((prevProjects) => prevProjects.filter((project) => project.id !== deleteProjectId));
        setIsProjectDeletePopupVisible(false);
        setDeleteProjectId(null);
        }
        else if(deletetype=='projectbanner'){
            try {
                // Make API call to delete the image
                const response = await axios.post(`${baseURL}/builder/deletebannerimage`, {
                    id: deleteProjectId,
                });
                setProjectBannerImages(projectBannerImages.filter((_, i) => i !== indexvaldelete));
                setIsProjectDeletePopupVisible(false);
                setDeleteProjectId(null);
                toast.success("Banner deleted successfully!");
            } catch (error) {
                console.error('Error deleting banner image:', error);
            }
        }

        else if(deletetype=='websitebanner'){
            if (deleteProjectId === undefined) {
                setBannerImages(bannerImages.filter((_, i) => i !== indexvaldelete));
                setIsProjectDeletePopupVisible(false);
                setDeleteProjectId(null);
                toast.success("Banner deleted successfully!");
            } else {
                try {
                    const response = await axios.post(`${baseURL}/website/deletewebsitebannerimage`, {
                        id: deleteProjectId,
                    });
                    setBannerImages(bannerImages.filter((_, i) => i !== indexvaldelete));
                    setIsProjectDeletePopupVisible(false);
                    setDeleteProjectId(null);
                    toast.success("Banner deleted successfully!");
                } catch (error) {
                    console.error('Error deleting website banner image:', error);
                }
            }
        }

        else if(deletetype=='websitetestimonial'){
            if (deleteProjectId === undefined) {
                setTestimonials(testimonials.filter((_, i) => i !== indexvaldelete));
                setIsProjectDeletePopupVisible(false);
                setDeleteProjectId(null);
                toast.success("Testimonial deleted successfully!");
            } else {
                try {
                    const response = await axios.post(`${baseURL}/website/deletewebsitetestimonial`, {
                        id: deleteProjectId,
                    });
                    setTestimonials(testimonials.filter((_, i) => i !== indexvaldelete));
                    setIsProjectDeletePopupVisible(false);
                    setDeleteProjectId(null);
                    toast.success("Testimonial deleted successfully!");
                } catch (error) {
                    console.error('Error deleting website banner image:', error);
                }
            }
        }

        else if(deletetype=='websitegallery'){
            if (deleteProjectId === undefined) {
                setGalleryImages(galleryImages.filter((_, i) => i !== indexvaldelete));
                setIsProjectDeletePopupVisible(false);
                setDeleteProjectId(null);
                toast.success("Image deleted successfully!");
            } else {
                try {
                    const response = await axios.post(`${baseURL}/website/deletewebsitegallery`, {
                        id: deleteProjectId,
                    });
                    setGalleryImages(galleryImages.filter((_, i) => i !== indexvaldelete));
                    setIsProjectDeletePopupVisible(false);
                    setDeleteProjectId(null);
                    toast.success("Image deleted successfully!");
                } catch (error) {
                    console.error('Error deleting website banner image:', error);
                }
            }
        }
    };

    //close delete click
    const handleCloseClickdelete = () => {
        setIsProjectDeletePopupVisible(false);
        setDeleteProjectId(null);
        setIsindexvaldelete('')
    };


    // editorBoxBody
    const [activeIndices, setActiveIndices] = useState([]);

    const toggleEditorBox = (index) => {
        setActiveIndices((prevIndices) =>
            prevIndices.includes(index)
            ? prevIndices.filter((i) => i !== index) // Remove index if already active
            : [...prevIndices, index] // Add index if not active
        );
    };


    // project upload
    const handleProjectLogoUpload = (files) => {
        if (projectLogoImages.length + files.length <= 1) {
            const newLogos = files.map((file) => URL.createObjectURL(file));
            setProjectLogoImages([...projectLogoImages, ...newLogos]);
        } else {
            alert('Maximum 1 logo image allowed!');
        }
        setLogoError("");
    };
    

    const handleProjectLogoDrop = (e) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);
        handleProjectLogoUpload(files);
    };
    
    const removeProjectLogoImage = (index) => {
        setProjectLogoImages(projectLogoImages.filter((_, i) => i !== index));
    };


    const handleProjectBannerUpload = (files) => {
        if (projectBannerImages.length + files.length <= 4) {
            const newImages = files.map((file) => ({
                url: URL.createObjectURL(file), // Use tempUrl for new file uploads
                id: null, // Initially, there is no id until the image is uploaded,
                isNew: true,
            }));
            setProjectBannerImages([...projectBannerImages, ...newImages]);
        } else {
            alert('Maximum 4 banner images allowed!');
        }
        SetbannerlogoError("");
    };

    const handleProjectBannerDrop = (e) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);
        handleProjectBannerUpload(files);
    };
    


    // text editor
    const [content, setContent] = useState("");

    // Handle content change
    const handleChange = (value) => {
        setContent(value);

        const isFormInvalid = 
            !formData.projectName || 
            !formData.phoneNumber || 
            !projectStatusval || 
            !formData.locationName.trim() || 
            !content.trim();

        if (!content) {
            setErrors(prev => ({ ...prev, contentError: 'Please enter the data' }));
        } else {
            setErrors(prev => ({ ...prev, contentError: '' }));
        }

        if (isFormInvalid) {
            SetprojectDetailserror("Please fill the required fields of project details");
        } else {
            SetprojectDetailserror("");     
        }
    };

    // Advanced toolbar options
    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }], // Headers
            ["bold", "italic", "underline", "strike"], // Text styling
            [{ color: [] }, { background: [] }], // Text and background color
            [{ script: "sub" }, { script: "super" }], // Subscript / superscript
            [{ list: "ordered" }, { list: "bullet" }], // Lists
            [{ indent: "-1" }, { indent: "+1" }], // Indent
            [{ align: [] }], // Text alignment
            ["blockquote"], // Blockquote and code block
            ["link"], // Media
            ["clean"], // Remove formatting
        ],
    };

    // Formats allowed in the editor
    const formats = [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "color",
        "background",
        "script",
        "list",
        "bullet",
        "indent",
        "align",
        "blockquote",
        "link",
    ];

    const [uploadedFiles, setUploadedFiles] = useState([]);

    // Handle file upload
    const handleFileUpload = (files) => {
        if (uploadedFiles.length + files.length <= 1) {
            const filePreviews = files.map((file) => ({
            name: file.name,
            type: file.type,
            url: URL.createObjectURL(file),
            isNew: true
            }));
            setUploadedFiles((prev) => [...prev, ...filePreviews]);
        } else {
        alert('Only 1 brochure allowed!');
        }
    };

    // Remove file from preview
    const removeUploadedFile = (index) => {
        setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
    };

    // File drop handler
    const handleFileDrop = (e) => {
        e.preventDefault();
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
        handleFileUpload(Array.from(e.dataTransfer.files));
        }
    };


    // project status dropdown
    const projectStatus = [
        {
            options: [
                'Select Project Status',
                'On Going',
                'Completed',
                'Just Launched',
            ]
        }
    ];

    // mobileProfileMenuClick
    const mobileProfileMenuClick = () => {
        setIsProfileMenuActive((prev) => !prev); // Toggle filter section
        document.body.style.overflow = 'hidden'; // Hide overflow when sidemenu is active
        setIsShimmerVisible(true);
    };

    // shimmerClick
    const shimmerClick = () => {
        setIsProfileMenuActive((prev) => !prev); // Toggle filter section
        document.body.style.overflow = 'inherit'; // Hide overflow when sidemenu is active
        setIsShimmerVisible(false);
    }

    // menuTabClick
    const menuTabClick = () => {
        setIsProfileMenuActive((prev) => !prev); // Toggle filter section
        document.body.style.overflow = 'inherit'; // Hide overflow when sidemenu is active
        setIsShimmerVisible(false);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }




    //add project section
 // addProjectClick

 const [isImageupload, setisImageupload] = useState(false);

 const fetch_project_by_id = async (projectid) => {
    try {
        const response = await axios.post(`${baseURL}/builder/fetch_project_by_id`, {
            projectid: projectid,
        });
        const projectDetails = response.data.projectDetails[0]; // Get the first project if multiple projects are returned
      
        // Set the project logo image URL as an array
        const logoUrl = mediaUrl+projectDetails.project_logo;
        setProjectLogoImages([logoUrl]); // Wrap the logo URL in an array

            const bannerImages = response.data.bannerImages;
            const bannerImageUrls = bannerImages.map(image => ({
                id: image.id,
                url: mediaUrl + image.banner_images,
                isNew: false,
            }));
        setProjectBannerImages(bannerImageUrls);
        // Update the form data
        setFormData({
            projectName: projectDetails.project_name || "",
            phoneNumber: projectDetails.phone_number || "",
            optionalPhoneNumber: projectDetails.optional_phone_number || "",
            projectDetails: projectDetails.description_val || "",
            locationName: projectDetails.location_val || "", // Assuming location name is available
        });
        
        setContent(projectDetails.description_val || "",)
        setProjectStatus(projectDetails.project_status || "")

        const ebrochure_pdf_url=mediaUrl+projectDetails.ebrochure_pdf
        const fileName = ebrochure_pdf_url.split('/').pop();

        if(projectDetails.ebrochure_pdf){
        setUploadedFiles(response.data.projectDetails)
        }
        setisImageupload(true)
    } catch (error) {
        console.error(error);
    }
};

const [currentProjectId, setCurrentProjectId] = useState(null);
const addProjectClick = (projectid) => {
    setIsProjectUploadPopupVisible(true);
    setCurrentProjectId(projectid);
    document.body.style.overflow = 'hidden';
    if (projectid !== undefined) {
        fetch_project_by_id(projectid);  // Calling the function with projectid
    }
};


    const [projectStatusval, setProjectStatus] = useState('');

    const validateField = (name, value) => {
        let errorMessage = '';
        switch (name) {
            case 'projectName':
                if (!value.trim()) errorMessage = 'Project name is required';
                break;
            case 'phoneNumber':
                if (!value.trim()) errorMessage = 'Phone number is required';
                break;
            case 'locationName':
                if (!value.trim()) errorMessage = 'Please enter location';
                break;
            default:
                break;
        }
        return errorMessage;
    };
    

    const handleInputChange = (e) => {
        const { name, value } = e.target;
    
        // Update form data
        setFormData((prev) => ({ ...prev, [name]: value }));
    
        // Validate the specific field
        const error = validateField(name, value);
        setErrors((prev) => ({ ...prev, [name]: error }));
    
        // Validate the overall form for required fields
        const isFormInvalid = 
            !formData.projectName || 
            !formData.phoneNumber || 
            !projectStatusval || 
            !formData.locationName.trim() || 
            !content.trim();
    
        if (isFormInvalid) {
            SetprojectDetailserror("Please fill the required fields of project details");
        } else {
            SetprojectDetailserror("");     
        }
    };
    
    

    const handleProjectStatusChange = (selectedStatus) => {
            setProjectStatus(selectedStatus);
            if (!selectedStatus) {
                setErrors(prev => ({ ...prev, projectStatusval: 'Choose project status' }));
            } else {
                setErrors(prev => ({ ...prev, projectStatusval: '' }));
            }
        };

        const [errors, setErrors] = useState({ projectName: '', phoneNumber: '', serviceInnerDescription: '', serviceImage: '',contentError:'',locationName:'' });
        const [isDisable, setIsDisable] = useState(false);
        const [error, setError] = useState(false);

        const [logoError, setLogoError] = useState('');
        const [bannerlogoError, SetbannerlogoError] = useState('');
        const [projectDetailserror, SetprojectDetailserror] = useState('');
        const [buttonText, setButtonText] = useState('Submit');
    
    const handleSubmitproject = async () => {
        let valid = true;
        
        if (!formData.projectName) {
            setErrors(prev => ({ ...prev, projectName: 'Project name is required' }));
            popupRef.current.scrollTop = 600;
            valid = false;
        } else {
            setErrors(prev => ({ ...prev, projectName: '' }));
        }
    
        if (!formData.phoneNumber) {
            popupRef.current.scrollTop = 600;
            setErrors(prev => ({ ...prev, phoneNumber: 'Phone number is required' }));
            valid = false;
        } else {
            setErrors(prev => ({ ...prev, phoneNumber: '' }));
        }
        if (!projectStatusval) {
            popupRef.current.scrollTop = 600;
            setErrors(prev => ({ ...prev, projectStatusval: 'Choose project status' }));
            valid = false;
        } else {
            setErrors(prev => ({ ...prev, projectStatusval: '' }));
        }
        if (!formData.locationName) {
            popupRef.current.scrollTop = 600;
            setErrors(prev => ({ ...prev, locationName: 'Please enter location' }));
            valid = false;
        } else {
            setErrors(prev => ({ ...prev, locationName: '' }));
        }
    
        if (!content) {
            setErrors(prev => ({ ...prev, contentError: 'Please enter the data' }));
            valid = false;
        } else {
            setErrors(prev => ({ ...prev, contentError: '' }));
        }
    
        if (projectLogoImages.length === 0) {
            setLogoError("Please upload a project logo image.");
            popupRef.current.scrollTop = 0;
            valid = false;
        } else {
            setLogoError("");
        }
    
        if (projectBannerImages.length === 0) {
            popupRef.current.scrollTop = 300;
            SetbannerlogoError("Please upload at least one banner image for the project.");
            valid = false;
        } else {
            SetbannerlogoError("");
        }
    
        if (!formData.projectName || !formData.phoneNumber|| !projectStatusval || !formData.locationName ||!content) {
            SetprojectDetailserror("Please fill the required fields of project details");
        }
        else{
            SetprojectDetailserror("");     
        }

        if (!valid) {
            setError(true);
            setIsDisable(false);
            return;
        }
        setButtonText('Submitting...');
        setIsDisable(true); 
        // Prepare submission data
        const submissionData = new FormData();
        const login_id = localStorage.getItem('login_id');
        submissionData.append("projectName", formData.projectName);
        submissionData.append("projectStatus", projectStatusval);
        submissionData.append("phoneNumber", formData.phoneNumber);
        submissionData.append("optionalPhoneNumber", formData.optionalPhoneNumber);
        submissionData.append("descriptionval", content);
        submissionData.append("builder_log_id", login_id);
        submissionData.append("location_val", formData.locationName);
        submissionData.append("project_id_val", currentProjectId);
        
        // Append uploaded files
        try {
            if (uploadedFiles?.length > 0) {
                const fileData = uploadedFiles[0];
                const isNewFile = fileData.isNew;
                if (isNewFile) {
                    const response = await fetch(fileData.url);
                    const blob = await response.blob();
                    const file = new File([blob], fileData.name, { type: fileData.type });
                    submissionData.append("ebrochure_pdf", file);
                }
                else{
                    submissionData.append("ebrochure_pdf", '');
                }
            }
    
            if (projectLogoImages?.length > 0) {
                const logoImage = projectLogoImages[0];
            
                if (logoImage.startsWith("blob:")) {
                    const response = await fetch(logoImage);
                    const blob = await response.blob();
                    const file = new File([blob], "projectLogo.png", { type: blob.type });
                    submissionData.append("projectLogoImages", file);
                } else {
                    submissionData.append("projectLogoImages",'');
                }
            }
            
    
            for (let index = 0; index < projectBannerImages.length; index++) {
                const image = projectBannerImages[index];
                if (image.isNew) {
                    const response = await fetch(image.url);
                    const blob = await response.blob();
                    const file = new File([blob], `projectBanner${index}.png`, { type: blob.type });
                    submissionData.append(`projectBannerImages`, file);
                } else {
                    submissionData.append(`projectBannerImages`, ''); // Append URL directly
                }
            }

        } catch (error) {
            console.error("Error preparing files for submission:", error);
        }
    

        // add the data of project
        if(currentProjectId==undefined){
        try {
            const response = await axios.post(`${baseURL}/builder/addProjectdetails`, submissionData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
    
            if (response?.status === 200) {
                toast.success("Project uploaded successfully!");
                setTimeout(() => {
                    setIsProjectUploadPopupVisible(false);
                    setFormData({
                        projectName: '',
                        phoneNumber: '',
                        optionalPhoneNumber: '',
                        locationName:'',
                    });
                    setContent('');
                    setErrors({});
                    setProjectStatus('');
                    setLogoError('');
                    SetbannerlogoError('');
                    setProjectLogoImages([]);
                    setProjectBannerImages([]);
                    setUploadedFiles([]);
                    setButtonText('Submit');
                    setIsDisable(false);
                    fetchUserDetailsproject()
                    fetch_website_details();
                }, 1500);
            }
            else {
                throw new Error("Unknown response from server");
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to upload project.";
            console.error("Error occurred during project upload:", errorMessage);
            toast.error(errorMessage);
        }finally {
            //setIsDisable(false); // Re-enable the button
        } 
    }

    //edit the data of project
      else{

        try {
            const response = await axios.post(`${baseURL}/builder/editProjectDetails`, submissionData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
    
            if (response?.status === 200) {
                toast.success("Project uploaded successfully!");
                setTimeout(() => {
                    setIsProjectUploadPopupVisible(false);
                    setFormData({
                        projectName: '',
                        phoneNumber: '',
                        optionalPhoneNumber: '',
                        locationName:'',
                    });
                    setContent('');
                    setErrors({});
                    setProjectStatus('');
                    setLogoError('');
                    SetbannerlogoError('');
                    setProjectLogoImages([]);
                    setProjectBannerImages([]);
                    setUploadedFiles([]);
                    setButtonText('Submit');
                    fetchUserDetailsproject()
                    fetch_website_details();
                }, 1500);
                
            }
            else {
                throw new Error("Unknown response from server");
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to upload project.";
            console.error("Error occurred during project upload:", errorMessage);
            toast.error(errorMessage);
        }finally {
            setIsDisable(false); // Re-enable the button
        } 
      }  
    };
    


    useEffect(() => {
        fetch_website_details();
        fetchMyproperty_get();
        fetchSavedProperties();
        fetchContactedProperties();
        setispropertyloading(false);
      }, []); 

      const [myallPropertydata,SetmyallPropertydata]=useState([]);
      const fetchMyproperty_get = async (Pstatus) => {
        const login_id = localStorage.getItem('login_id');
        try {
        const response = await axios.post(`${baseURL}/fetchMyproperty_get`, {
            login_id: login_id,
        });
        //console.log(response.data)
       if(response.data.length==0){
    
       }
       else{
        SetmyallPropertydata(response.data)
       }
    
    }
    catch (error) {
        console.error(error);
    }
    }

      const [ChcekPorjects,SetChcekPorjects]=useState('none');
      
      const fetchUserDetailsproject = async () => {
        const login_id = localStorage.getItem('login_id');
        try {
        const response = await axios.post(`${baseURL}/builder/fetchprojectDeatils`, {
            login_id: login_id,
        });
       if(response.data.length==0){
        SetChcekPorjects('block')
       }
       else{
        SetChcekPorjects('none')
       }
        setProjects2(response.data);
        setProjects(response.data);
    }
    catch (error) {
        console.error(error);
    }
}

// const [myPropertydata,SetmyPropertydata]=useState([]);
// const fetchPropertyDetails_get = async (Pstatus) => {
//     const login_id = localStorage.getItem('login_id');
//     try {
//     const response = await axios.post(`${baseURL}/fetchPropertyDetails_get`, {
//         login_id: login_id,
//         Pstatus:Pstatus,
//     });
//    if(response.data.length==0){

//    }
//    else{
//     SetmyPropertydata(response.data.propertydetails)
//    }

// }
// catch (error) {
//     console.error(error);
// }
// }

const { myPropertydata, loading1, error1 } = useSelector((state) => state.myproperty);

//website add section
const [companyerror, SetCompanyError] = useState({});
const [websitelogosectionError, SetwebsitelogosectionError] = useState('');
const [websitelogocompError, SetwebsitelogocompError] = useState('');
const [websitebannererr, Setwebsitebannererr] = useState('');
const [webeaboutrrors, setwebaboutErrors] = useState({ title: '', description: '', experience: ''});
const [websectioneaboutrrors, Setwebsectioneaboutrrors] = useState('');
const [webcontactErrors, setwebcontactErrors] = useState({ phone1: '', email: '', address1: '', address2: '', address3: ''});
const [webcontactsecErrors, setwebcontactsecErrors] = useState('');

const [isDisableweb, setIsDisableWeb] = useState(false);
const [buttonTextweb, setButtonTextweb] = useState('Submit your site');

const submitWebsite = async() => {
    let valid = true;

        if (!companyName.trim() ) {
            window.scrollTo({ top: 0, behavior: "smooth" });
            SetCompanyError((prev) => ({ ...prev, name: 'Company name is required' }));
            valid = false;
        } else {
            if(companyName.includes("'")){
                window.scrollTo({ top: 0, behavior: "smooth" });
                SetCompanyError((prev) => ({ ...prev, name: "Ensure the company name does not contain a single quote (')" }));
                valid = false;
            }
            else{
                SetCompanyError((prev) => ({ ...prev, name: '' }));
            }
        }

        if (logoImages.length === 0) {
            window.scrollTo({ top: 0, behavior: "smooth" });
            SetwebsitelogosectionError("Please upload a logo.");
            valid = false;
        } else {
            SetwebsitelogosectionError("");
        }

        if(!companyName.trim() || logoImages.length === 0){
            SetwebsitelogocompError("Please fill the  logo section.");
            valid = false;
        }
        else {
            SetwebsitelogocompError("");
        }

        if (bannerImages.length === 0) {
            window.scrollTo({ top: 100, behavior: "smooth" });
            Setwebsitebannererr("Please upload at least one banner image for the website.");
            valid = false;
        } else {
            Setwebsitebannererr("");
        }

        if(!about.title){
            setwebaboutErrors(prev => ({ ...prev, title: 'Please enter the title' }));
            window.scrollTo({ top: 150, behavior: "smooth" });
            valid = false;
        }else{
            setwebaboutErrors(prev => ({ ...prev, title: '' }));
        }

        if(!about.description){
            window.scrollTo({ top: 150, behavior: "smooth" });
            setwebaboutErrors(prev => ({ ...prev, description: 'Please enter the description' }));
            valid = false;
        }else{
            setwebaboutErrors(prev => ({ ...prev, description: '' }));
        }

        if(!about.experience){
            window.scrollTo({ top: 150, behavior: "smooth" });
            setwebaboutErrors(prev => ({ ...prev, experience: 'Please enter the experience' }));
            valid = false;
        }else{
            setwebaboutErrors(prev => ({ ...prev, experience: '' }));
        }

        if(!about.title || !about.description || !about.experience){
            Setwebsectioneaboutrrors("Please fill the  about section datas.");
            valid = false;
        }
        else {
            Setwebsectioneaboutrrors("");
        }

        if(!contact.phone1){
            setwebcontactErrors(prev => ({ ...prev, phone1: 'Please enter the phone number' }));
            window.scrollTo({ top: 300, behavior: "smooth" });
            valid = false;
        }else{
            setwebcontactErrors(prev => ({ ...prev, phone1: '' }));
        }
        if(!contact.email){
            setwebcontactErrors(prev => ({ ...prev, email: 'Please enter the email' }));
            window.scrollTo({ top: 300, behavior: "smooth" });
            valid = false;
        }else{
            setwebcontactErrors(prev => ({ ...prev, email: '' }));
        }
        if(!contact.address1){
            window.scrollTo({ top: 300, behavior: "smooth" });
            setwebcontactErrors(prev => ({ ...prev, address1: 'Please enter the adress line1' }));
            valid = false;
        }else{
            setwebcontactErrors(prev => ({ ...prev, address1: '' }));
        }   
        if(!contact.address2){
            window.scrollTo({ top: 300, behavior: "smooth" });
            setwebcontactErrors(prev => ({ ...prev, address2: 'Please enter the adress line2' }));
            valid = false;
        }else{
            setwebcontactErrors(prev => ({ ...prev, address2: '' }));
        } 
        if(!contact.address3){
            window.scrollTo({ top: 300, behavior: "smooth" });
            setwebcontactErrors(prev => ({ ...prev, address3: 'Please enter the adress line3' }));
            valid = false;
        }else{
            setwebcontactErrors(prev => ({ ...prev, address3: '' }));
        }    

        if(!contact.phone1 || !contact.email || !contact.address1 || !contact.address2 || !contact.address3 ){
            setwebcontactsecErrors("Please fill the contact fields data");
            valid = false;
        }else{
            setwebcontactsecErrors("");
        }

        const isValid = testimonials.every(item => {
            return (item.message.trim() && item.name.trim()) || (!item.message.trim() && !item.name.trim());
        });
        
        if (!isValid) {
            valid = false;
            //window.scrollTo({ top: 300, behavior: "smooth" });
            toast.error('Plase enter both name and message on testimonial!')
            settestimonialerror('Plase enter both name and message!')
        } else {
            let testimonialsJSON = JSON.stringify(testimonials);
            console.log("Valid JSON:", testimonialsJSON);
            settestimonialerror("")
        }


        if (!valid) {
            setIsDisable(false);
            return;
        }
        setButtonTextweb('Submitting...');
        setIsDisable(true); 

    let facebook_val='';
    if(contact.facebook==undefined){
        facebook_val='';
    }  
    else{
        facebook_val=contact.facebook;
    }  

    let instagram_val='';
    if(contact.instagram==undefined){
        instagram_val='';
    }  
    else{
        instagram_val=contact.instagram;
    } 
    
    let linkedin_val='';
    if(contact.linkedin==undefined){
        linkedin_val='';
    }  
    else{
        linkedin_val=contact.linkedin;
    } 

    let youtube_val='';
    if(contact.youtube==undefined){
        youtube_val='';
    }  
    else{
        youtube_val=contact.youtube;
    } 

    const submissionData = new FormData();
    const login_id = localStorage.getItem('login_id');
    submissionData.append("builder_log_id", login_id);
    submissionData.append("company_name", companyName.replace(/\s+/g, ''));
    submissionData.append("about_title", about.title);
    submissionData.append("about_description", about.description);
    submissionData.append("experience_val", about.experience);
    submissionData.append("project_id_arr", JSON.stringify(checkedProjectid));
    submissionData.append("property_id_arr", JSON.stringify(PropertiesId));
    submissionData.append("testimonial_arr", JSON.stringify(testimonials));
    submissionData.append("phone_number1", contact.phone1);
    submissionData.append("phone_number2", contact.phone2);
    submissionData.append("email_id", contact.email);
    submissionData.append("address_line1", contact.address1);
    submissionData.append("address_line2", contact.address2);
    submissionData.append("address_line3", contact.address3);
    submissionData.append("facebook_val", facebook_val);
    submissionData.append("instagram_val",instagram_val);
    submissionData.append("linkedin_val", linkedin_val);
    submissionData.append("youtube_val", youtube_val);
    if (logoImages?.length > 0) {
                const logoImage = logoImages[0];
            
                if (logoImage.startsWith("blob:")) {
                    const response = await fetch(logoImage);
                    const blob = await response.blob();
                    const file = new File([blob], "websitelogo.png", { type: blob.type });
                    submissionData.append("websitelogo_image", file);
                } else {
                    submissionData.append("websitelogo_image",'');
                }
            }
            
            for (let index = 0; index < bannerImages.length; index++) {
                const image = bannerImages[index];
                if (image.isNew) {
                    const response = await fetch(image.url);
                    const blob = await response.blob();
                    const file = new File([blob], `websiteBanner${index}.png`, { type: blob.type });
                    submissionData.append(`websitebannerImages`, file);
                } else {
                    submissionData.append(`websitebannerImages`, ''); // Append URL directly
                }
            }

            for (let index = 0; index < galleryImages.length; index++) {
                const image = galleryImages[index];
                if (image.isNew) {
                    const response = await fetch(image.url);
                    const blob = await response.blob();
                    const file = new File([blob], `galleryImg${index}.png`, { type: blob.type });
                    submissionData.append(`galleryImges`, file);
                } else {
                    submissionData.append(`galleryImges`, ''); // Append URL directly
                }
            }

            try {
                const response = await axios.post(`${baseURL}/website/addwebsutedeatils`, submissionData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
                if (response?.status === 200) {
                    toast.success("Your Website Now Live");
                    setTimeout(() => {
                        
                        // setwebcontactErrors({
                        //     phone1: '',
                        //     phone2: '',
                        //     email: '',
                        //     address1:'',
                        //     address2:'',
                        //     address3:'',
                        //     facebook:'',
                        //     instagram:'',
                        //     youtube:'',
                        //     linkedin:'',
                        // });

                        // setAbout({
                        //     title: '',
                        //     experience: '',
                        //     description: '',
                        // });
                        // setProjectsid([])
                        // setCompanyName('');
                        // setTestimonials([]);
                        // setPropertiesId([]);
                        // setProjectBannerImages([]);
                        // setUploadedFiles([]);
                        setButtonTextweb('Submit your site');
                        window.location.href=`${path}${companyName}`
                    }, 1500);
                    fetch_website_details();
                }
                
                else {
                    throw new Error("Unknown response from server");
                }
            } catch (error) { 
                if (error.response.status === 401) {
                    setButtonTextweb('Submit your site');
                    toast.error(error.response.data.error);
                    setIsDisable(false);
                }
                else{
                const errorMessage = error.response?.data?.message || error.message || "Failed to upload project.";
                console.error("Error occurred during project upload:", errorMessage);
                toast.error(errorMessage);
                 }
            }finally {
                setIsDisable(false); // Re-enable the button
            } 
}

const handleLogoUpload = (files) => {
    if (files.length > 1 || logoImages.length + files.length > 1) {
        alert('Maximum 1 logo image allowed!');
        return;
    }
    const newLogos = files.map((file) => URL.createObjectURL(file));
    setLogoImages((prevLogos) => [...prevLogos, ...newLogos]);

    // Validate the logo section
    const isLogoValid = newLogos.length > 0 || logoImages.length > 0;
    SetwebsitelogosectionError(isLogoValid ? '' : 'Please upload a logo image.');

    // Validate company name and logo section
    const isFormValid = companyName.trim() && isLogoValid;
    SetwebsitelogocompError(isFormValid ? '' : 'Please fill the logo section.');
};

useEffect(() => {
    return () => {
        logoImages.forEach((url) => URL.revokeObjectURL(url));
    };
    return () => {
        bannerImages.forEach((image) => URL.revokeObjectURL(image.url));
    };
}, [logoImages],[bannerImages]);


const handleBannerUpload = (files) => {
    const maxBannerImages = 4;
    if (files.length + bannerImages.length > maxBannerImages) {
        alert(`You can only upload up to ${maxBannerImages} banner images!`);
        return;
    }
    const newImages = files.map((file) => ({
        url: URL.createObjectURL(file),
        isNew: true,
    }));
    setBannerImages((prevBannerImages) => [...prevBannerImages, ...newImages]);
    const totalImages = bannerImages.length + files.length;
    Setwebsitebannererr(
        totalImages === 0
            ? 'Please upload at least one banner image for the website.'
            : ''
    );
};

const handleAboutChange = (e) => {
    const { name, value } = e.target; // Get the name and value from the input

    setAbout((prevState) => {
        const updatedAbout = {
            ...prevState,
            [name]: value, // Dynamically update the key based on the input's name
        };

        if(!updatedAbout.title){
            setwebaboutErrors(prev => ({ ...prev, title: 'Please enter the title' }));
        }else{
            setwebaboutErrors(prev => ({ ...prev, title: '' }));
        }

        if(!updatedAbout.description){
            setwebaboutErrors(prev => ({ ...prev, description: 'Please enter the description' }));
        }else{
            setwebaboutErrors(prev => ({ ...prev, description: '' }));
        }

        if(!updatedAbout.experience){
            setwebaboutErrors(prev => ({ ...prev, experience: 'Please enter the experience' }));
        }else{
            setwebaboutErrors(prev => ({ ...prev, experience: '' }));
        }

        if (!updatedAbout.title || !updatedAbout.description || !updatedAbout.experience) {
            Setwebsectioneaboutrrors("Please fill the about section datas.");
        } else {
            Setwebsectioneaboutrrors("");
        }

        return updatedAbout; // Return the updated state
    });
};

const handleContactChange = (e) => {
    const { name, value } = e.target; // Extract name and value from the input field

    // Update the contact state
    setContact((prevState) => {
        const updatedState = { ...prevState, [name]: value };

        // Perform validation for each field dynamically based on the updated state
        setwebcontactErrors((prev) => ({
            ...prev,
            phone1: !updatedState.phone1 ? 'Please enter the phone number' : '',
            email: !updatedState.email ? 'Please enter the email' : '',
            address1: !updatedState.address1 ? 'Please enter the address line 1' : '',
            address2: !updatedState.address2 ? 'Please enter the address line 2' : '',
            address3: !updatedState.address3 ? 'Please enter the address line 3' : '',
        }));

        // Check if any field is still empty and update section-level errors
        const hasEmptyFields =
            !updatedState.phone1 ||
            !updatedState.email ||
            !updatedState.address1 ||
            !updatedState.address2 ||
            !updatedState.address3;

        setwebcontactsecErrors(hasEmptyFields ? 'Please fill the contact fields data' : '');

        return updatedState; // Return the updated state
    });
};

//fetch website details

const [properties, setProperties] = useState([])

const fetch_website_details= async () => {
    const login_id = localStorage.getItem('login_id');
    try {
        const response = await axios.post(`${baseURL}/website/fetch_website_details`, {
            login_id: login_id,
        });
        //console.log(response.data)
        if(response.data.websiteDetails.length==0){
            fetchUserDetailsproject();
            setWebsiteProjectdeatils(response.data.projects)
            const projectIds = response.data.projects
            .filter((project) => project.checked === true)
            .map((project) => project.id);
            setProjectsid(projectIds)
            setProperties(response.data.property)

            const propertyId = response.data.property
            .filter((property) => property.checked === true)
            .map((property) => property.propertyId);
            setPropertiesId(propertyId)
        }
        else{
            setWebsiteProjectdeatils(response.data.projects)
            fetchUserDetailsproject();
            setProjects(response.data.projects);
            setProjects2(response.data.projects);
            const projectIds = response.data.projects
            .filter((project) => project.checked === true)
            .map((project) => project.id);
            setProjectsid(projectIds)
            setProperties(response.data.property)
        
            const propertyId = response.data.property
            .filter((property) => property.checked === true)
            .map((property) => property.propertyId);
            setPropertiesId(propertyId)

        const websiteDetails=response.data.websiteDetails[0];
        setCompanyName(websiteDetails.company_name)
        setAbout({
        title: websiteDetails.about_title,
        experience: websiteDetails.experience_val,
        description:websiteDetails.about_description,
         });
         setContact({
            phone1: websiteDetails.phone_number1,
            phone2: websiteDetails.phone_number2,
            email: websiteDetails.email_id,
            address1:websiteDetails.address_line1,
            address2:websiteDetails.address_line2,
            address3:websiteDetails.address_line3,
            facebook:websiteDetails.facebook_val,
            instagram:websiteDetails.instagram_val,
            youtube:websiteDetails.linkedin_val,
            linkedin:websiteDetails.youtube_val,
            });


            const logoUrl = mediaUrl+websiteDetails.logo_image;
             setLogoImages([logoUrl]);

            const galleryImages = response.data.galleryImages;
            const gallerymageUrls = galleryImages.map(image => ({
                id: image.id,
                url: mediaUrl + image.gallery_images,
                isNew: false,
            }));
            setGalleryImages(gallerymageUrls);

            const bannerImages = response.data.bannerImages;
            const bannermageUrls = bannerImages.map(image => ({
                id: image.id,
                url: mediaUrl + image.banner_images,
                isNew: false,
            }));
            setBannerImages(bannermageUrls);

            const tetstimonialdata = response.data.testimonials;
            setTestimonials(
                tetstimonialdata.map((testimonial) => ({
                    id: testimonial.id,
                    name: testimonial.name_val,
                    message: testimonial.message_val,
                    testimonial_status:testimonial.testimonial_status,
                }))
            );
        }
    } catch (error) {
        console.error(error);
    }
}

//fetch user details
const [Characterfirst, setCharacterfirst] = useState(['']);
const [Logphonenum, setLogphonenum] = useState();

// const fetchUserDetails_get = async () => {  
//     const login_id = localStorage.getItem('login_id');
//     try {
//         const response = await axios.post(`${baseURL}/fetchuserdetailsid`, {
//             login_id: login_id,
//         });
//         console.log(response.data)
//         const userdetails=response.data.userdetails[0];
//         const alternativenum=response.data.alternativenum;
//         const personaldetails=response.data.personaldetails[0];

//             setUserDetails(userdetails);
//             setName(userdetails.userName)
//             setLogphonenum(userdetails.phone_number)
//             setCharacterfirst(userdetails.userName.charAt(0))
//             setSelectedRole(userdetails.role_val)
//             setformplaceData({
//                 experiance_val:personaldetails.experiance_val,
//             })
//             setSelectedDistrict(personaldetails.district)
//             setSelectedTown(personaldetails.town)

//             if(userdetails.role_val=='Agent'){
//             }
//             else{
//             }

//             if (Array.isArray(alternativenum)) {
//                 setPhoneNumbers(alternativenum.map(item => item.phone_number.toString()));
//             }
//             setIsNumberTemplateVisible(true); 

//     } catch (error) {
//         console.error(error);
//     }
// };  

//update profile datas
const [isPopupVisible, setIsPopupVisible] = useContext(LoginPopupContext);

const updateSubmit = async(e) => {
   e.preventDefault();
   let valid = true;
   if(!name){
    toast.error('Please enter the name');
    valid = false;
    }else{

    }
if (!valid) {
    return;
}
   const submissionData = new FormData();
    const login_id = localStorage.getItem('login_id');
    submissionData.append("login_id", login_id);
    submissionData.append("phone_number_val", Logphonenum);
    submissionData.append("name_val", name);
    submissionData.append("role_val", selectedRole);
    submissionData.append("district_val", selectedDistrict);
    submissionData.append("town_val", selectedTown);
    submissionData.append("experiance_val", formplaceData.experiance_val);
    submissionData.append("alternative_number_arr", JSON.stringify(phoneNumbers));
    try {
        const response = await axios.post(`${baseURL}/editprofiledetails`, submissionData, {
            headers: { "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            toast.success("Profile details updated successfully")
            //fetchUserDetails_get();
            localStorage.setItem('roleval', selectedRole);
            updateRole(selectedRole);
            dispatch(fetchUserDetails(login_id));
        }
    }catch (error) { 
        const errorMessage = error.response?.data?.message || error.message || "Failed to upload project.";
        console.error("Error occurred during project upload:", errorMessage);
        toast.error(errorMessage);
         
    }finally {

    } 
     
}

//logout
const handleLogout = async (e) => {
    e.preventDefault();
          localStorage.removeItem('jwtToken');
          localStorage.removeItem('login_id');
          localStorage.removeItem('roleval');
          localStorage.removeItem('districtval');
          functionlogout()
          dispatch(resetUserState());
          fetchpropertydetails();
          settokenval(localStorage.removeItem('jwtToken'))
          toast.success('Logged out successfully');
  };

  const functionlogout = async () => {
    try {
        const response = await axios.post(
            'https://keralaplots.com/Official/logoutsession.php',
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            }
        );
        console.log(response.data);
    } catch (error) {
    }
};

  const [formplaceData, setformplaceData] = useState({
                district_val: '',
                town_val:'',
                experiance_val:'',
            });

  const handleplaceClick = async (e) => {
        const { name, value } = e.target;
        setformplaceData((prev) => ({ ...prev, [name]: value }));
  }

  // Function to fetch saved properties
  const fetchSavedProperties = async () => {

    const login_id = localStorage.getItem('login_id');

    if (!login_id) return; // Ensure login_id exists

    try {
        const response = await axios.get(`${baseURL}/fetchSavedProperties`, {
            params: { login_id }
        });


        if (Array.isArray(response.data) && response.data.length > 0) {
            setsavedP(response.data);  // ✅ Set the array directly
            setisLoadingsaved(false)
        } else {
            setsavedP([]);  // Reset state if empty
            setisLoadingsaved(false)
        }

    } catch (error) {
        console.error("Error fetching saved properties:", error);
    }
};

const [ContactedPropeties,SetContactedPropeties]=useState([]);

const fetchContactedProperties= async()=>{
    const login_id = localStorage.getItem('login_id');
    const response=await axios.post(`${baseURL}/fetchContactedProperties`,{
        login_id:login_id
    })

    if(response.data.length>0){
        SetContactedPropeties(response.data)
        setisLoadingcontacted(false)
    }
    else{
        setisLoadingcontacted(false)
    }
}
  
  //fetch properties
  const fetchPropertydetailsuser=async()=>{
    const login_id = localStorage.getItem('login_id');
    const response=await axios.post(`${baseURL}/builder/fetchPropertiesget`,{
        login_id:login_id
    })
  }

  const [propertyclickval,Setpropertyclickval]=useState(1);

  const [ispropertyloading,setispropertyloading]=useState(true);
  
  const handleClick = async (propertyStatus) => { 
    setispropertyloading(true); // Set loading before fetch
    dispatch(fetchmyPropertyDetails(propertyStatus))
        .unwrap()
        .then((data) => {
            setispropertyloading(false); // Stop loading
            if (data.length === 0) {
                console.log("No properties found");
            }
        })
        .catch(() => setispropertyloading(false)); // Stop loading on error
    Setpropertyclickval(propertyStatus);
};


const [SelectedPropertyId,setSelectedPropertyId]=useState();
const handlePropertySettingClick = (propertyId) => {
    setSelectedPropertyId(propertyId);
  };

//   district
const [district, setDistrict] = useState([]);
const [town, setTown] = useState([]);
const [selectedDistrict, setSelectedDistrict] = useState(null);
const [selectedTown, setSelectedTown] = useState(null);
const districtList = [
    {
        options: [
            'Trivandrum',
            'Kollam',
            'Alleppey',
            'Pathanamthitta',
            'Kottayam',
            'Idukki',
            'Ernakulam',
            'Thrissur',
            'Palakkad',
            'Malappuram',
            'Kozhikode',
            'Wayanad',
            'Kannur',
            'Kasargod'
        ]
    }
];

/**const townList = [
    {
        options: [
            'townList 1',
            'townList 2',
        ]
    }
];*/

// When district is selected, fetch towns for that district
const handleDistrictChange = (selectedValue) => {
    const district = selectedValue?.name || selectedValue;
    //console.log("Changing district to:", district);
    //console.log("Resetting selected town...");
    setSelectedDistrict(district);
    setSelectedTown(null);
    fetchTownsByDistrict(district)
    
    // fetchTowns(district);
};

// When district is selected, fetch towns for that district
const handleTownChange = (selectedValue) => {
    const town = selectedValue?.name || selectedValue;
    setSelectedTown(town);
};

const fetchTownsByDistrict = (district) => {
    if (!district) return;  // Prevent making API call if district is empty

    // Call the API to fetch towns by district (replace with your actual API endpoint)
    axios.get(`${baseURL}/get-towns/${district}`)
        .then((response) => {
            //console.log(response.data)
            const formattedTownList = [{
                options: response.data.map(town => town.area_name) // Adjust based on actual API response structure
            }];
            setTownList(formattedTownList);  // Set the town list based on API response
            //console.log(townList)
        })
        .catch((error) => {
            //console.error('Error fetching towns:', error);  // Handle error
        });
};



const fetchStoressessionvalues = async (loginId) => {
    try {
        const response = await axios.post(
            'https://keralaplots.com/Official/create_session.php',
            { loginId: loginId },
            {
                headers: {
                    'Content-Type': 'application/json', // Ensure the server knows you're sending JSON
                },
                withCredentials: true, // Include cookies in the request
            }
        );
        console.log(response.data);  // Log the response from the server
    } catch (error) {
        //toast.error(error.response?.data?.error || "An error occurred. Please try again.");
    }
};

const login_id = localStorage.getItem('login_id');
const { userDetails, personalDetails, phoneNumbers1, CompletedProperties, PendingProperties,inactiveProperties, loading } = useSelector(
    (state) => state.user
);

// Fetch user details and property details on component mount

const [phoneNumberget,setphoneNumberget]=useState([]);

useEffect(() => {
  if (login_id) {
    dispatch(fetchUserDetails(login_id)); 
    dispatch(fetchPropertyDetails({ login_id, Pstatus: '1' }));
    dispatch(fetchmyPropertyDetails(1));
  }
}, [dispatch, login_id]);

// Update state when userDetails or personalDetails changes
const [Addedate,setAddeddate]=useState('');
useEffect(() => {
  if (userDetails) {
    setName(userDetails.userName || "");
    setLogphonenum(userDetails.phone_number || "");
    setFormData({
        phone: userDetails.phone_number || "",
      });
    setCharacterfirst(userDetails.userName ? userDetails.userName.charAt(0) : "");
    setSelectedRole(userDetails.role_val || "");
    setAddeddate(userDetails.added_date_time || "")
  }

  if (personalDetails) {
    setformplaceData({
      experiance_val: personalDetails.experiance_val || "",
    });
    setSelectedDistrict(personalDetails.district || "");
    setSelectedTown(personalDetails.town || "");
  }

  if (Array.isArray(phoneNumbers1)) {
    setPhoneNumbers(phoneNumbers1.map(item => item.phone_number.toString()));
    setphoneNumberget(phoneNumbers1.map(item => ({ id: item.id, phone_number: item.phone_number.toString() })) )
}


  setIsNumberTemplateVisible(true);

}, [userDetails, personalDetails, phoneNumbers1]); // Runs when any of these values change



    // handleCopy
    const handleCopy = () => {
        const login_id=localStorage.getItem('login_id')
        if(selectedRole=='Builder'){
            const content = `Property: ${name}\n${window.location.origin}/keralaplots/${companyName}`;
            navigator.clipboard.writeText(content);
            toast.success(`Copied: ${content}`);
        }
         else if(selectedRole=='Agent'){
            const content = `Property: ${name}\n${window.location.origin}/innerAgent/${login_id}`;
            navigator.clipboard.writeText(content);
            toast.success(`Copied: ${content}`);
         }
    }

    // handleShareWhatsapp
    const handleShareWhatsapp = () => {
        const login_id=localStorage.getItem('login_id')
        if(selectedRole=='Builder'){
            const content = `Property: ${name}\n${window.location.origin}/keralaplots/${companyName}`;
            const url = `whatsapp://send?text=${encodeURIComponent(content)}`;
            window && window.open(url, '_blank');
        }
         else if(selectedRole=='Agent'){
            const content = `Property: ${name}\n${window.location.origin}/innerAgent/${login_id}`;
            const url = `whatsapp://send?text=${encodeURIComponent(content)}`;
            window && window.open(url, '_blank');
         }
    }   


    const carouselRef = useRef(null); // Reference for carousel
    const myPropertiesRef = useRef(null);
    const contactedPropertiesRef = useRef(null);
    const savedPropertiesRef = useRef(null);

    const settings = {
      dots: false,
      loop: false,
      nav: false, // Disable default navigation
      margin: 20,
      autoplay: false,
      responsive: {
        0: { items: 1 },
        600: { items: 2 },
        1000: { items: 3 },
        1200: { items: 3 },
      },
    };

    const settings1 = {
        dots: false,
        loop: true,
        nav: false, // Disable default navigation
        margin: 20,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        responsive: {
        0: { items: 1 },
        600: { items: 1 },
        1000: { items: 1 },
        1200: { items: 1 },
        },
    };
  
    // Custom Next & Prev Handlers
    const goToNext = (ref) => {
        if (ref.current) {
            ref.current.next();
        }
    };
    
    const goToPrev = (ref) => {
        if (ref.current) {
            ref.current.prev();
        }
    };
      
    // testimonials expand
    const [expandedIndex, setExpandedIndex] = useState(null);
    const [expandable, setExpandable] = useState([]);
    const textRefs = useRef({});

    useEffect(() => {
        setTimeout(() => {
            if (testimonials.length > 0) {
                const results = testimonials.map((_, index) => {
                    const ref = textRefs.current[index];
                    return ref && ref.scrollHeight > ref.clientHeight;
                });
                setExpandable(results);
            }
        }, 100);
    }, [testimonials]); // Run effect when testimonials change

    const toggleExpand = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };
    
    return (
        <>
            <Tooltip id="my-tooltip" />

            {isShimmerVisible && (
                <div className="shimmer" onClick={shimmerClick}></div>
            )}

            {/* name form popup */}
            {isNameEditPopupVisible && (
                <div className="formPopup nameEditPopup">
                    <div className="formPopupBox">
                        <div className="closeFormPopup" onClick={handleCloseClick}>
                            <RiCloseLargeFill />
                        </div>
                        <form  onSubmit={handleNameSubmit}>
                            <h2>Edit Name</h2>
                            <div className="formGroup">
                                <label htmlFor="">Name</label>
                                <input 
                                    type="text"
                                    id="nameInput"
                                    placeholder="Enter Your Name"
                                    value={name}
                                    onChange={handleNameChange} 
                                />
                            </div>
                            <div className="formBtnArea">
                                <button type="submit">Update</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            {/* name form popup close */}

            {/* phone number form popup */}
            {isNumberEditPopupVisible && (
                <div className="formPopup numberEditPopup">
                    <div className="formPopupBox">
                        <div className="closeFormPopup" onClick={handleCloseClick}>
                            <RiCloseLargeFill />
                        </div>
                        <form >
                            <h2>Edit Phone Number</h2>
                            <div className="formGroup">
                                <label htmlFor="">Phone Number</label>
                                <input
                                    type="text"
                                    name="phone"
                                    placeholder="Enter Phone Number"
                                    maxLength="10"
                                    value={formData.phone}
                                    onChange={handlePhoneChange}
                                />
                            </div>

                            {/* Get OTP Button */}
                            <div className="formOtpInput">
                                {!showOtpInput && (
                                    <div className="getOtpBtn" onClick={handleGetOtp}>
                                        Get OTP
                                    </div>
                                )}

                                {/* OTP Input Group */}
                                {showOtpGroup && (
                                    <div className="formOtpInputGroup">
                                        <label>Enter OTP</label>
                                        <div className="formOtpInputBox">
                                            <input
                                                type="text"
                                                placeholder="000000"
                                                maxLength="6"
                                                value={formData.otp}
                                                onChange={handleOtpChange}
                                            />
                                            <div className="otpTimer">
                                                {timer > 0 ? `${timer}s` : "Time's up!"}
                                            </div>
                                            {showResendBtn && (
                                                <div
                                                    className="resendOtpBtn"
                                                    onClick={handleResendOtp}
                                                >
                                                    Resend OTP
                                                </div>
                                            )}
                                            <div className="otpExpaireAlert">
                                                {!generatedOtp && (
                                                    <span>OTP has expired. Please click "Resend OTP" to receive a new one.</span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Continue Button */}
                            {showOtpGroup && (
                                <div className="formBtnArea">
                                    <button
                                        type="button"
                                        disabled={!isFormBtnEnabled || !generatedOtp}
                                        onClick={handleOtpSubmit}
                                    >
                                        Update
                                    </button>
                                </div>
                            )}
                        </form>
                    </div>
                </div>
            )}



        {isNumberEditPopupVisiblealter && (
                <div className="formPopup numberEditPopup">
                    <div className="formPopupBox">
                        <div className="closeFormPopup" onClick={handleCloseClick}>
                            <RiCloseLargeFill />
                        </div>
                        <form >
                            <h2>Edit Phone Number</h2>
                            <div className="formGroup">
                                <label htmlFor="">Phone Number</label>
                                <input
                                    type="text"
                                    name="phone"
                                    placeholder="Enter Phone Number"
                                    maxLength="10"
                                    value={selectedPhoneNumber}
                                    onChange={handlePhoneChangealter}
                                />
                            </div>
                            {phonnumberalterexisterr && <span className="error-message">{phonnumberalterexisterr}</span>}
                          
                            <div className="formOtpInput">
                                {!showOtpInput && (
                                    <div className="getOtpBtn" onClick={handleGetOtpalter}>
                                        Get OTP
                                    </div>
                                )}

                            
                                {showOtpGroup && (
                                    <div className="formOtpInputGroup">
                                        <label>Enter OTP</label>
                                        <div className="formOtpInputBox">
                                            <input
                                                type="text"
                                                placeholder="000000"
                                                maxLength="6"
                                                value={formData.otp}
                                                onChange={handleOtpChangealter}
                                            />
                                            <div className="otpTimer">
                                                {timer > 0 ? `${timer}s` : "Time's up!"}
                                            </div>
                                            {showResendBtn && (
                                                <div
                                                    className="resendOtpBtn"
                                                    onClick={handleResendOtpalter}
                                                >
                                                    Resend OTP
                                                </div>
                                            )}
                                            <div className="otpExpaireAlert">
                                                {!generatedOtp && (
                                                    <span>OTP has expired. Please click "Resend OTP" to receive a new one.</span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                           
                            {showOtpGroup && (
                                <div className="formBtnArea">
                                    <button
                                        type="button"
                                        disabled={!isFormBtnEnabled || !generatedOtp}
                                        onClick={handleOtpSubmitalter}
                                    >
                                        Update
                                    </button>
                                </div>
                            )}
                        </form>
                    </div>
                </div>
            )}

            {/* phone number form popup close */}

            {/* phone number form popup */}
            {isNumberAddPopupVisible && (
                <div className="formPopup numberEditPopup">
                    <div className="formPopupBox">
                        <div className="closeFormPopup" onClick={handleCloseClick}>
                            <RiCloseLargeFill />
                        </div>
                        <form >
                            <h2>Add Phone Number</h2>
                            <div className="formGroup">
                                <label htmlFor="">Phone Number</label>
                                <input
                                    type="text"
                                    name="phone2" // Corrected name to match the state key
                                    placeholder="Enter Phone Number"
                                    maxLength="10"
                                    value={formData2.phone2} // Binds to the correct state value
                                    onChange={handlePhoneChange2} // Uses the correct handler
                                />
                            </div>
                            {phonnumberalterexisterr && <span className="error-message">{phonnumberalterexisterr}</span>}
                            {/* Get OTP Button */}
                            <div className="formOtpInput">
                                {!showOtpInput && (
                                    <div className="getOtpBtn" onClick={handleGetOtp2}>
                                        Get OTP
                                    </div>
                                )}

                                {/* OTP Input Group */}
                                {showOtpGroup && (
                                    <div className="formOtpInputGroup">
                                        <label>Enter OTP</label>
                                        <div className="formOtpInputBox">
                                            <input
                                                type="text"
                                                name="otp2"
                                                placeholder="000000"
                                                maxLength="6"
                                                value={formData2.otp2} // Bind to otp2
                                                onChange={handleOtpChange2} // Use updated handler
                                            />
                                            <div className="otpTimer">
                                                {timer > 0 ? `${timer}s` : "Time's up!"}
                                            </div>
                                            {showResendBtn && (
                                                <div
                                                    className="resendOtpBtn"
                                                    onClick={handleResendOtp}
                                                >
                                                    Resend OTP
                                                </div>
                                            )}
                                            <div className="otpExpaireAlert">
                                                {!generatedOtp && (
                                                    <span>OTP has expired. Please click "Resend OTP" to receive a new one.</span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Continue Button */}
                            {showOtpGroup && (
                                <div className="formBtnArea">
                                    <button
                                        type="button"
                                        disabled={!isFormBtnEnabled || !generatedOtp}
                                        onClick={handleOtpSubmit2}
                                    >
                                        Continue
                                    </button>
                                </div>
                            )}
                        </form>
                    </div>
                </div>
            )}
            {/* phone number form popup close */}

            {/* property setting popup */}
            {isSettingPopupVisible && (
                <div className="propertySettingPopup">
                    <div className="propertySettingPopupBox">
                        <div className="closePropertySettingPopup" onClick={handleCloseClick}>
                            <RiCloseLargeFill />
                        </div>
                        <ul>
                            <li>
                                <a 
                                    href="#" 
                                    className="propertySettingBtn" 
                                    onClick={(e) => {
                                        e.preventDefault(); // Prevent default navigation
                                        const Tokenval = localStorage.getItem("jwtToken"); 
                                        if (!Tokenval) {
                                            setIsPopupVisible(true); // Show login popup
                                        } else {
                                            fetchStoressessionvalues(localStorage.getItem("login_id"));
                                            window.open(`https://keralaplots.com/keralaplots/postProperty/post-basic-info.html?id=${SelectedPropertyId}`, "_blank");
                                        }
                                    }}
                                    >
                                    <div className="icon">
                                        <RiEditLine />
                                    </div>
                                    <p>Edit Property</p>
                                </a>
                            </li>
                            <li>
                                <div className="propertySettingBtn" onClick={addtoSoldClick}>
                                    <div className="icon">
                                        <BsBuildingCheck />
                                    </div>
                                    <p>Add to Sold</p>
                                </div>
                            </li>
                            <li>
                                <div className="propertySettingBtn" onClick={movetoInactiveClick}>
                                    <div className="icon">
                                        <BsBuildingExclamation />
                                    </div>
                                    <p>Move to Inactive</p>
                                </div>
                            </li>
                            <li>
                                <div className="propertySettingBtn" onClick={deletPropertyClick}>
                                    <div className="icon">
                                        <RiDeleteBin6Line />
                                    </div>
                                    <p>Delete Property</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            )}
            {/* property setting popup close */}

            {/* property delete popup */}
            {isDeletePopupVisible && (
                <div className="propertyDeletePopup">
                    <div className="propertyDeletePopupBox">
                        <div className="closePropertyDeletePopup" onClick={handleCloseClick}>
                            <RiCloseLargeFill />
                        </div>
                        <div className="propertyDeletePopupBoxDetails">
                            <h3>Confirm Delete?</h3>
                            <p>You can't recover the property after delete.</p>
                            <div className="propertyDeletePopupBoxDetailsBtnArea">
                                <div className="confrimDeleteBtn" onClick={submitDeleteClick}>Delete</div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* property delete popup close */}

            {/* account deactivate popup */}
            {isDeactivatePopupVisible && (
            <div className="accountDeactivatePopup">
                <div className="accountDeactivatePopupBox">
                    <div className="closeAccountDeactivatePopup" onClick={handleCloseClick}>
                        <RiCloseLargeFill />
                    </div>
                    <div className="accountDeactivatePopupBoxDetails">
                        <h3>Confirm Deactivate Account?</h3>
                        <p>You can't recover the data after deactivate.</p>
                        <div className="accountDeactivatePopupBoxDetailsBtnArea">
                            <div className="confrimDeactivateBtn" onClick={submitDeactivateClick}>Deactivate</div>
                        </div>
                    </div>
                </div>
            </div>
            )}
            {/* account deactivate popup close */}

            {/* project delete popup */}
            {isProjectDeletePopupVisible && (
                <div className="propertyDeletePopup">
                    <div className="propertyDeletePopupBox">
                        <div className="closePropertyDeletePopup" onClick={handleCloseClickdelete}>
                            <RiCloseLargeFill />
                        </div>
                        <div className="propertyDeletePopupBoxDetails">
                            <h3>Confirm Delete?</h3>
                            <p>You can't recover the project after delete.</p>
                            <div className="propertyDeletePopupBoxDetailsBtnArea">
                                <div className="confrimDeleteBtn" onClick={submitProjectDeleteClick}>Delete</div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* project delete popup close */}

            {/* project upload popup */}
            {isProjectUploadPopupVisible && (
            <div className="projectUploadPopup" ref={popupRef}>
                <div className="projectUploadPopupBox">
                    <div className="closeProjectUploadPopup" onClick={handleCloseClick}>
                        <RiCloseLargeFill />
                    </div>
                    <div className="projectUploadPopupBoxForm">
                    <section className={`projectUploadBox ${activeIndices.includes(11) ? "active" : ""}`}>
                            <div className="editorBoxHead" onClick={() => toggleEditorBox(11)}>
                                <h3>Project Logo</h3>
                                <div className="editorBoxHeadExpandBtn">
                                    {activeIndices.includes(11) ? <MdRemove /> : <MdAdd />}
                                </div>
                            </div>
                            <div className="editorBoxBody" style={{ maxHeight: activeIndices.includes(11) ? "100%" : "0" }}>
                                <div className="editorBoxBodyMain">
                                    <div
                                        className="logo-dropzone"
                                        onDragOver={(e) => e.preventDefault()}
                                        onDrop={handleProjectLogoDrop}
                                    >
                                        <label className="custom-file-upload">
                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={(e) => handleProjectLogoUpload(Array.from(e.target.files))}
                                            />
                                            <div className="uploadIcon">
                                                <AiOutlineCloudUpload />
                                            </div>
                                            <p>Upload logo Image</p>
                                        </label>
                                    </div>
                                    <div className="logo-preview">
                                        {projectLogoImages.map((src, index) => (
                                            <div key={index} className="logo-item">
                                                <img src={src} alt={`logo ${index}`} className="logo-preview-image" />
                                                <button className="logoImageDeleteBtn" onClick={() => removeProjectLogoImage(index)}><RiDeleteBin7Line /></button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                
                            </div>
                        </section>
                        {logoError && <span className="error-message">{logoError}</span>}
                        
                        <section className={`projectUploadBox ${activeIndices.includes(12) ? "active" : ""}`}>
                            <div className="editorBoxHead" onClick={() => toggleEditorBox(12)}>
                                <h3>Banner</h3>
                                <div className="editorBoxHeadExpandBtn">
                                    {activeIndices.includes(12) ? <MdRemove /> : <MdAdd />}
                                </div>
                            </div>
                            <div className="editorBoxBody" style={{ maxHeight: activeIndices.includes(12) ? "100%" : "0" }}>
                            <div className="editorBoxBodyMain">
                                <div
                                    className="banner-dropzone"
                                    onDragOver={(e) => e.preventDefault()}
                                    onDrop={handleProjectBannerDrop}
                                >
                                    <label className="custom-file-upload">
                                        <input
                                            type="file"
                                            multiple
                                            accept="image/*"
                                            onChange={(e) => handleProjectBannerUpload(Array.from(e.target.files))}
                                        />
                                        <div className="uploadIcon">
                                            <AiOutlineCloudUpload />
                                        </div>
                                        <p>Upload Banner Images</p>
                                    </label>
                                </div>
                                <div className="banner-preview">
                                    {projectBannerImages.map((image, index) => (
                                        <div key={image.id || index} className="banner-item">
                                            <img
                                                src={image.tempUrl || image.url} // Use tempUrl for new uploads, url for backend images
                                                alt={`Project Banner ${index + 1}`}
                                                className="banner-preview-image"
                                            />
                                            <button
                                                className="bannerImageDeleteBtn"
                                                onClick={() => removeProjectBannerImage(index, image.id)} // Use id if available
                                                aria-label={`Delete banner ${index + 1}`}
                                            >
                                                <RiDeleteBin7Line />
                                            </button>
                                        </div>
                                    ))}
                                </div>

                                </div>
                            </div>
                        </section>
                        {bannerlogoError && <span className="error-message">{bannerlogoError}</span>}

                        <section className={`projectUploadBox ${activeIndices.includes(13) ? "active" : ""}`}>
                            <div className="editorBoxHead" onClick={() => toggleEditorBox(13)}>
                                <h3>Project Details</h3>
                                <div className="editorBoxHeadExpandBtn">
                                    {activeIndices.includes(13) ? <MdRemove /> : <MdAdd />}
                                </div>
                            </div>
                            <div className="editorBoxBody" style={{ maxHeight: activeIndices.includes(13) ? "100%" : "0" }}>
                                <div className="editorBoxBodyMain">
                                    <div className="editorBoxForm">
                                        <div className="editorBoxFormBox">
                                            <input
                                                type="text"
                                                placeholder="Project Name"
                                                name="projectName"
                                                value={formData.projectName}
                                                onChange={handleInputChange}
                                            />
                                            {errors.projectName && <span className="error-message">{errors.projectName}</span>}
                                        </div>

                                        <div className="editorBoxFormBox">
                                            <CustomSingleSelectDropdown
                                                options={projectStatus}  // Example options, replace with your dynamic list
                                                label="Project Status"
                                                value={projectStatusval}  // Set the selected project status value here
                                                onChange={handleProjectStatusChange}  // Handle the change
                                            />
                                            {errors.projectStatusval && <span className="error-message">{errors.projectStatusval}</span>}
                                        </div>

                                        <div className="editorBoxFormBox">
                                            <input
                                                 type="number"
                                                 name="phoneNumber"
                                                 value={formData.phoneNumber}
                                                 onChange={handleInputChange}
                                                 placeholder="Phone Number"
                                            />
                                            {errors.phoneNumber && <span className="error-message">{errors.phoneNumber}</span>}
                                        </div>
                                        <div className="editorBoxFormBox">
                                            <input
                                                type="number"
                                                name="optionalPhoneNumber"
                                                value={formData.optionalPhoneNumber}
                                                onChange={handleInputChange}
                                                placeholder="Phone Number (Optional)"
                                            />
                                        </div>
                                        <div className="editorBoxFormBox">
                                            <input
                                                type="text"
                                                placeholder="Loction"
                                                name="locationName"
                                                value={formData.locationName}
                                                onChange={handleInputChange}
                                            />
                                            {errors.locationName && <span className="error-message">{errors.locationName}</span>}
                                        </div>
                                        <div className="editorBoxFormBoxTeaxtarea">
                                            <ReactQuill
                                                value={content}
                                                onChange={handleChange}
                                                modules={modules}
                                                formats={formats}
                                                theme="snow" // The "snow" theme gives the editor a clean look
                                                placeholder="Start writing here..."
                                                style={{ minHeight: "300px" }}
                                            />
                                            {errors.contentError && <span className="error-message">{errors.contentError}</span>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {projectDetailserror && <span className="error-message">{projectDetailserror}</span>}
                        
                        <section className={`projectUploadBox ${activeIndices.includes(14) ? "active" : ""}`}>
                            <div className="editorBoxHead" onClick={() => toggleEditorBox(14)}>
                                <h3>E-brochure</h3>
                                <div className="editorBoxHeadExpandBtn">
                                    {activeIndices.includes(14) ? <MdRemove /> : <MdAdd />}
                                </div>
                            </div>
                            <div className="editorBoxBody" style={{ maxHeight: activeIndices.includes(14) ? "100%" : "0" }}>
                                <div className="editorBoxBodyMain">
                                    <div
                                        className="banner-dropzone"
                                        onDragOver={(e) => e.preventDefault()}
                                        onDrop={handleFileDrop}
                                        >
                                        <label className="custom-file-upload">
                                            <input
                                            type="file"
                                            multiple
                                            accept=".pdf"
                                            onChange={(e) => handleFileUpload(Array.from(e.target.files))}
                                            />
                                            <div className="uploadIcon">
                                            <AiOutlineCloudUpload />
                                            </div>
                                            <p>Upload Files</p>
                                        </label>
                                    </div>
                                    <div className="banner-preview">
                                        {uploadedFiles.map((file, index) => (
                                        <div key={index} className="banner-item">
                                            <img
                                                src={fileImg}
                                                className="banner-preview-image pdfImg"
                                            />
                                            <div className="file-preview">
                                                <p>{file.name}</p>
                                            </div>
                                            <button
                                            className="bannerImageDeleteBtn"
                                            onClick={() => removeUploadedFile(index)}
                                            >
                                            <RiDeleteBin7Line />
                                            </button>
                                        </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </section>
                        <div className="projectUploadPopupBoxFormBtnArea">
                            <button 
                                onClick={handleSubmitproject} 
                                className="projectUploadPopupBoxFormSubmitBtn"
                                disabled={isDisable}
                            >
                                 {buttonText}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            )}
            {/* project upload popup close */}

            <Tabs>
                <section id="myProfile">
                    <div className="container">
                        <div className="myProfileHead">
                            <div className="profileMenuBar" onClick={mobileProfileMenuClick}>
                                <span></span><span></span><span></span>
                            </div>
                            <h2 className="myProfileTitle">My Profile</h2>
                        </div>
                        <div className="myProfileMain">
                            {isLoading ? (
                                <div className='SkeletonLoader'>
                                    <div className='SkeletonLoaderBox'>
                                        <div className="SkeletonLoaderBoxCol1">
                                            <Skeleton />
                                        </div>
                                        <div className="SkeletonLoaderBoxCol2">
                                            <Skeleton />
                                        </div>
                                    </div>
                                    <div className='SkeletonLoaderBox'>
                                        <div className="SkeletonLoaderBoxCol1">
                                            <Skeleton />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className={isProfileMenuActive ? "myProfileMenu myProfileMenuActive" : "myProfileMenu"}>
                                        <div className="myProfileMenuHead">
                                            <div className="myProfileMenuHeadBox">
                                                <div className="myProfileMenuHeadBoxThumbnail">
                                                    <h4>{Characterfirst}</h4>
                                                </div>
                                                <div className="myProfileMenuHeadBoxDetails">
                                                    <div className="profileName">{name}</div>
                                                    <div className="profileType">{selectedRole}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="myProfileMenuBody">
                                            <TabList>
                                                <div className="myProfileMenuBodyBox">
                                                    <Tab onClick={menuTabClick}>
                                                        <div className="icon">
                                                            <RiDashboardLine />
                                                        </div>
                                                        <p>Dashboard</p>
                                                    </Tab>
                                                    <Tab onClick={menuTabClick}>
                                                        <div className="icon">
                                                            <RiUser3Line />
                                                        </div>
                                                        <p>My Profile</p>
                                                    </Tab>
                                                    <Tab onClick={menuTabClick}>
                                                        <div className="icon">
                                                            <RiBuilding4Line />
                                                        </div>
                                                        <p>My Properties</p>
                                                    </Tab>
                                                    <a 
                                                    href="#" 
                                                    className="myProfileMenuTab" 
                                                    onClick={(e) => {
                                                        e.preventDefault(); // Prevent default navigation
                                                        const Tokenval = localStorage.getItem("jwtToken"); 
                                                        if (!Tokenval) {
                                                            setIsPopupVisible(true); // Show login popup
                                                        } else {
                                                            fetchStoressessionvalues(localStorage.getItem("login_id"));
                                                            window.open("https://keralaplots.com/keralaplots/postProperty/post-basic-info.html?id=0", "_blank");
                                                        }
                                                    }}
                                                   >
                                                    <div className="icon">
                                                        <BsBuildingUp />
                                                    </div>
                                                    <p>Post Properties</p>
                                                </a>
                                                    
                                                    <Tab onClick={menuTabClick}>
                                                        <div className="icon">
                                                            <RiContactsBook2Line />
                                                        </div>
                                                        <p>Contacted Properties</p>
                                                    </Tab>
                                                    <Tab onClick={menuTabClick}>
                                                        <div className="icon">
                                                            <RiHomeHeartLine />
                                                        </div>
                                                        <p>Saved Properties</p>
                                                    </Tab>
                                                    {selectedRole === 'Builder' && (
                                                    <Tab onClick={menuTabClick}>
                                                        <div className="icon">
                                                            <RiBuilding2Line />
                                                        </div>
                                                        <p>Post Projects</p>
                                                    </Tab>
                                                    )}
                                                    {selectedRole === 'Builder' && (
                                                    <Tab onClick={menuTabClick}>
                                                        <div className="icon">
                                                            <LuLayoutTemplate />
                                                        </div>
                                                        <p>Create Your Own Site</p>
                                                        <div className="menuTag">
                                                            {/* <div className="newTag">New</div> */}
                                                        </div>
                                                    </Tab>
                                                    )}
                                                    <div className="lineBreak"></div>
                                                    {/* <div className="myProfileMenuTab" onClick={deactivateAccountClick}>
                                                        <div className="icon">
                                                            <RiUserUnfollowLine />
                                                        </div>
                                                        <p>Deactivate Account</p>
                                                    </div> */}
                                                    <div className="myProfileMenuTab">
                                                        <div className="icon">
                                                            <RiLogoutCircleRLine />
                                                        </div>
                                                        <p onClick={handleLogout}>Logout</p>
                                                    </div>
                                                </div>
                                            </TabList>
                                        </div>
                                    </div>
                                </>
                            )}
                            <div className="myProfileCanvas">
                                <TabPanel>
                                    <Suspense fallback={<div>Loading...</div>}>
                                        <div className="myProfileCanvasDashboardBox">
                                            <div className="myProfileCanvasDashboardBoxHead">
                                                {isLoading ? (
                                                    <div className='SkeletonLoader2'>
                                                        <div className='SkeletonLoaderBox'>
                                                            <div className="SkeletonLoaderBoxCol1">
                                                                <Skeleton />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <div className="myProfileCanvasDashboardBoxHeadCol1">
                                                            <div className="profileCreated">Profile Created On : {Addedate}</div>
                                                            <div className="myProfileCanvasDashboardBoxProfile">
                                                                <div className="myProfileCanvasDashboardBoxProfileThumbnail">
                                                                    <h4>{Characterfirst}</h4>
                                                                </div>
                                                                <div className="myProfileCanvasDashboardBoxProfileDetails">
                                                                    <div className="profileName">{name}</div>
                                                                    <div className="profileType">{selectedRole}</div>
                                                                </div>
                                                            </div>
                                                            <div className="myProfileCanvasDashboardBoxContactNumber">
                                                                <h3>Phone Number</h3>
                                                                <ul>
                                                                    <li>+91 {Logphonenum}</li>
                                                                    {phoneNumbers.map((number, index) => (
                                                                        <li key={index}>+91 {number}</li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                                <div className="myProfileCanvasDashboardBoxHeadCol2">
                                                    {isLoading ? (
                                                        <div className='SkeletonLoader3'>
                                                            <div className='SkeletonLoaderBox'>
                                                                <div className="SkeletonLoaderBoxCol1">
                                                                    <Skeleton />
                                                                </div>
                                                                <div className="SkeletonLoaderBoxCol1">
                                                                    <Skeleton />
                                                                </div>
                                                                <div className="SkeletonLoaderBoxCol1">
                                                                    <Skeleton />
                                                                </div>
                                                                <div className="SkeletonLoaderBoxCol1">
                                                                    <Skeleton />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <div className="dashboardCountBox">
                                                                <div className="countBgImg">
                                                                    <img src={countBg1} alt="" />
                                                                </div>
                                                                <h4>{PendingProperties}</h4>
                                                                <p>Uploaded Properties</p>
                                                            </div>
                                                            <div className="dashboardCountBox">
                                                                <div className="countBgImg">
                                                                    <img src={countBg2} alt="" />
                                                                </div>
                                                                <h4>{CompletedProperties}</h4>
                                                                <p>Sold Properties</p>
                                                            </div>
                                                            <div className="dashboardCountBox">
                                                                <div className="countBgImg">
                                                                    <img src={countBg3} alt="" />
                                                                </div>
                                                                <h4>{PendingProperties}</h4>
                                                                <p>Pending Properties</p>
                                                            </div>
                                                            <div className="dashboardCountBox">
                                                                <div className="countBgImg">
                                                                    <img src={countBg4} alt="" />
                                                                </div>
                                                                <h4>{inactiveProperties}</h4>
                                                                <p>Inactive Properties</p>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                            {isLoading ? (
                                                <div className='SkeletonLoader4'>
                                                    <div className='SkeletonLoaderBox'>
                                                        <div className="SkeletonLoaderBoxCol1">
                                                            <Skeleton />
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                {selectedRole !== 'user' && (

                                                    <div className="profileShareStrip">
                                                        <div className="profileShareStripThumbnail">
                                                            <video
                                                                playsInline
                                                                preload="auto"
                                                                autoPlay
                                                                muted
                                                                loop
                                                            >
                                                                <source src={shareVideo} type="video/mp4" />
                                                            </video>
                                                        </div>
                                                        
                                                        <div className="profileShareStripDetails">
                                                            <h3>Hey, Share Your Profile</h3>
                                                            <p>Let others know more about you! Share your profile to connect with buyers, sellers, or agents and grow your network.</p>
                                                            <div className="profileShareBtn">Share Now <div className="icon"><RiShareForwardLine /></div>
                                                                <div className="propertySharePopup">
                                                                    <ul>
                                                                        <li className='copyLink' onClick={handleCopy}>
                                                                            <div className="icon">
                                                                                <FiCopy />
                                                                            </div>
                                                                            <p>Copy Link</p>
                                                                        </li>
                                                                        <li className='shareWhatsapp' onClick={handleShareWhatsapp}>
                                                                            <div className="icon">
                                                                                <MdWhatsapp />
                                                                            </div>
                                                                            <p>Share Whatsapp</p>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                          
                                                    </div>
                                                )}
                                                </>
                                            )}
                                            <div className="myProfileCanvasDashboardBoxList">
                                                {isLoading ? (
                                                            <div className='SkeletonLoader4'>
                                                                <div className='SkeletonLoaderBox'>
                                                                    <div className="SkeletonLoaderBoxCol1">
                                                                        <Skeleton />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                    <>
                                                        <div className="myProfileCanvasDashboardBoxListCol myPropertyItem">
                                                            <h2>My Properties</h2>
                                                            <div className="myPropertyListSlider">
                                                                {myallPropertydata.length > 0 ? (
                                                                    <div className="carouselWrapper">
                                                                        {/* Custom Prev Button */}
                                                                        <button className="customNavBtn prev" onClick={() => goToPrev(myPropertiesRef)}>
                                                                            <GoChevronLeft />
                                                                        </button>

                                                                        {/* Carousel */}
                                                                        <OwlCarousel {...settings} ref={myPropertiesRef}>
                                                                            {myallPropertydata.map((allPropertie) => (
                                                                                <PropertyBox 
                                                                                    key={allPropertie.propertyId}
                                                                                    propertyLink={`${path}innerProperty/${allPropertie.propertyId}/${allPropertie.propertyType.replace('/', '').replace(/\s+/g, '-')+"-for-"+allPropertie.propertyAction}`}
                                                                                    propertyImage={allPropertie.imageName ? `https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/${allPropertie.imageName}` : BASE_URL_NOIMG} 
                                                                                    propertyPurposeTag={allPropertie.propertyAction} 
                                                                                    propertyId={allPropertie.propertyId}
                                                                                    propertyName={`${allPropertie.propertyType} For ${allPropertie.propertyAction}`} 
                                                                                    propertyLocation={`${allPropertie.district}, ${allPropertie.town}`}
                                                                                    propertyDate={allPropertie.addedDate}
                                                                                    propertyPrice={allPropertie.priceVisibility === 'no' ? 'Not disclosed' : allPropertie.propertyPricerange} 
                                                                                    propertyType={allPropertie.propertyType}
                                                                                />
                                                                            ))}
                                                                        </OwlCarousel>

                                                                        {/* Custom Next Button */}
                                                                        <button className="customNavBtn next" onClick={() => goToNext(myPropertiesRef)}>
                                                                            <GoChevronRight />
                                                                        </button>
                                                                    </div>
                                                                    ) : (
                                                                    <div className="emptyPage">
                                                                        <div className="emptyPageMain">
                                                                            <div className="emptyPageBoxThumbnail">
                                                                                <video playsInline preload="auto" autoPlay muted loop>
                                                                                    <source src={emptyVideo} type="video/mp4" />
                                                                                </video>
                                                                            </div>
                                                                            <div className="emptyPageBoxDetails">
                                                                                <h2 className="title">You're not posted any properties yet!</h2>
                                                                                <p>You haven’t listed any properties yet! Start showcasing your property now to attract potential buyers or tenants effortlessly.</p>
                                                                                <Link to="https://keralaplots.com/keralaplots/postProperty/post-basic-info.html?id=0" target="_blank">
                                                                                    Post Properties
                                                                                </Link>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                {isLoadingcontacted ? (
                                                    <div className='SkeletonLoader4'>
                                                        <div className='SkeletonLoaderBox'>
                                                        {[...Array(2)].map((_, index) => (
                                                                <div key={index} className="SkeletonLoaderBox">
                                                                <div className="SkeletonLoaderBoxCol1">
                                                                    <Skeleton />
                                                                </div>
                                                                <div className="SkeletonLoaderBoxCol2">
                                                                    <div className="SkeletonLoaderBoxCol2Logo">
                                                                    <Skeleton />
                                                                    </div>
                                                                    <div className="SkeletonLoaderBoxCol2Name">
                                                                    <Skeleton />
                                                                    <Skeleton />
                                                                    </div>
                                                                </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <div className="myProfileCanvasDashboardBoxListCol">
                                                            <h2>Contacted Properties</h2>
                                                            <div className="myPropertyListSlider">
                                                            {Array.isArray(ContactedPropeties) && ContactedPropeties.length > 0 ? (
                                                                    <div className="carouselWrapper">
                                                                    {/* Custom Prev Button */}
                                                                    <button className="customNavBtn prev" onClick={() => goToPrev(contactedPropertiesRef)}>
                                                                    <GoChevronLeft />
                                                                    </button>

                                                                    {/* Carousel */}
                                                                    <OwlCarousel {...settings} ref={contactedPropertiesRef}>
                                                                        {ContactedPropeties.map((contactedp) => (
                                                                            // <Suspense key={contactedp.propertyId} fallback={<div>Loading...</div>}>
                                                                                <PropertyBox 
                                                                                    key={contactedp.propertyId}
                                                                                    propertyLink={`${path}innerProperty/${contactedp.propertyId}/${contactedp.propertyType.replace('/', '').replace(/\s+/g, '-') + "-for-" + contactedp.propertyAction}`}
                                                                                    propertyImage={contactedp.imageName ? `https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/${contactedp.imageName}` : BASE_URL_NOIMG} 
                                                                                    propertyPurposeTag={contactedp.propertyAction} 
                                                                                    propertyId={contactedp.propertyId}
                                                                                    propertyName={`${contactedp.propertyType} For ${contactedp.propertyAction}`} 
                                                                                    propertyLocation={`${contactedp.district} , ${contactedp.town}`}
                                                                                    propertyDate={contactedp.addedDate}
                                                                                    propertyPrice={contactedp.priceVisibility === 'no' ? 'Not disclosed' : contactedp.propertyPricerange} 
                                                                                    propertyType={contactedp.propertyType}
                                                                                    propertySeen={false}
                                                                                    propertyContacted={false}
                                                                                    savedStatus={contactedp.savedStatus} // Pass the savedStatus
                                                                                    addedId={contactedp.loginId}
                                                                                />
                                                                            // </Suspense>
                                                                        ))}
                                                                                </OwlCarousel>

                                                                    {/* Custom Next Button */}
                                                                    <button className="customNavBtn next" onClick={() => goToNext(contactedPropertiesRef)}>
                                                                    <GoChevronRight />
                                                                    </button>
                                                                    </div>
                                                                ) : (
                                                                    <div className="emptyPage">
                                                                        <div className="emptyPageMain">
                                                                            <div className="emptyPageBoxThumbnail">
                                                                                <video playsInline preload="auto" autoPlay muted loop>
                                                                                    <source src={emptyVideo} type="video/mp4" />
                                                                                </video>
                                                                            </div>
                                                                            <div className="emptyPageBoxDetails">
                                                                                <h2 className="title">You're not contacted any property yet!</h2>
                                                                                <p>You haven’t contacted any properties yet! Explore listings and reach out to find your ideal property with ease.</p>
                                                                                <Link to={`${path}properties`}>Explore Properties</Link>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                {isLoadingsaved ? (
                                                    <div className='SkeletonLoader4'>
                                                        <div className='SkeletonLoaderBox'>
                                                        {[...Array(2)].map((_, index) => (
                                                                <div key={index} className="SkeletonLoaderBox">
                                                                <div className="SkeletonLoaderBoxCol1">
                                                                    <Skeleton />
                                                                </div>
                                                                <div className="SkeletonLoaderBoxCol2">
                                                                    <div className="SkeletonLoaderBoxCol2Logo">
                                                                    <Skeleton />
                                                                    </div>
                                                                    <div className="SkeletonLoaderBoxCol2Name">
                                                                    <Skeleton />
                                                                    <Skeleton />
                                                                    </div>
                                                                </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <div className="myProfileCanvasDashboardBoxListCol">
                                                            <h2>Saved Properties</h2>
                                                            <div className="myPropertyListSlider">
                                                            {Array.isArray(savedP) && savedP.length > 0 ? (

                                                                            <div className="carouselWrapper">
                                                                            {/* Custom Prev Button */}
                                                                            <button className="customNavBtn prev" onClick={() => goToPrev(savedPropertiesRef)}>
                                                                            <GoChevronLeft />
                                                                            </button>

                                                                            {/* Carousel */}
                                                                            <OwlCarousel {...settings} ref={savedPropertiesRef}>
                                                                        {savedP.map((allsavedP) => (
                                                                            // <Suspense key={allsavedP.propertyId} fallback={<div>Loading...</div>}>
                                                                                <PropertyBox 
                                                                                    key={allsavedP.propertyId}
                                                                                    propertyLink={`${path}innerProperty/${allsavedP.propertyId}/${allsavedP.propertyType.replace('/', '').replace(/\s+/g, '-') + "-for-" + allsavedP.propertyAction}`}
                                                                                    propertyImage={allsavedP.imageName ? `https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/${allsavedP.imageName}` : BASE_URL_NOIMG} 
                                                                                    propertyPurposeTag={allsavedP.propertyAction} 
                                                                                    propertyId={allsavedP.propertyId}
                                                                                    propertyName={`${allsavedP.propertyType} For ${allsavedP.propertyAction}`} 
                                                                                    propertyLocation={`${allsavedP.district} , ${allsavedP.town}`}
                                                                                    propertyDate={allsavedP.addedDate}
                                                                                    propertyPrice={allsavedP.priceVisibility === 'no' ? 'Not disclosed' : allsavedP.propertyPricerange} 
                                                                                    propertyType={allsavedP.propertyType}
                                                                                    propertySeen={false}
                                                                                    propertyContacted={false}
                                                                                    savedStatus={1} // Pass the savedStatus
                                                                                />
                                                                            // </Suspense>
                                                                        ))}

                                                                            </OwlCarousel>

                                                                {/* Custom Next Button */}
                                                                <button className="customNavBtn next" onClick={() => goToNext(savedPropertiesRef)}>
                                                                <GoChevronRight />
                                                                </button>
                                                                </div>
                                                                ) : (
                                                                    <div className="emptyPage">
                                                                        <div className="emptyPageMain">
                                                                            <div className="emptyPageBoxThumbnail">
                                                                                <video playsInline preload="auto" autoPlay muted loop>
                                                                                    <source src={emptyVideo} type="video/mp4" />
                                                                                </video>
                                                                            </div>
                                                                            <div className="emptyPageBoxDetails">
                                                                                <h2 className="title">You haven’t saved anything yet!</h2>
                                                                                <p>You currently have no saved items. Start exploring and bookmarking your favorites to easily access them later!</p>
                                                                                <Link to={`${path}properties`}>Explore Properties</Link>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                            </div>
                                        </div>
                                    </Suspense>
                                </TabPanel>
                                <TabPanel>
                                    <Suspense fallback={<div>Loading...</div>}>
                                        <div className="myProfileCanvasProfileBox">
                                            <form action="">
                                                <div className="formProfileColumn">
                                                    <div className="formProfileHeadName">
                                                        <div className="formProfileHeadNameThumbnail">
                                                            <h4>{Characterfirst}</h4>
                                                        </div>
                                                        <div className="formProfileHeadNameInputBox">
                                                            <div className="formGroup">
                                                                <input type="text" placeholder="Name" value={name} disabled />
                                                            </div>
                                                            <div className="editBtn editNameBtn"
                                                                    data-tooltip-id="my-tooltip"
                                                                    data-tooltip-content="Edit Name"
                                                                    onClick={handleEditNameClick}
                                                                >
                                                                <RiEditLine />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="formProfileColumn">
                                                    <div className="formProfilePhoneNumberBox">
                                                        <label htmlFor="">Phone Number</label>

                                                        {/* Default Phone Number */}
                                                        <div className="formProfilePhoneNumberBoxInput">
                                                            <input type="text" value={` ${Logphonenum}`} disabled />
                                                            <div className="formProfilePhoneNumberBoxInputBtn">
                                                                <div
                                                                    className="editBtn editNumberNumber"
                                                                    data-tooltip-id="my-tooltip"
                                                                    data-tooltip-content="Edit Number"
                                                                    onClick={handleEditNumberClick}
                                                                >
                                                                    <RiEditLine />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Dynamically Rendered Phone Numbers */}
                                                        {isNumberTemplateVisible && (
                                                            <>
                                                                    {phoneNumberget.map((number, index) => (
                                                                    <div key={index} className="formProfilePhoneNumberBoxInput">
                                                                        <input type="text" value={number.phone_number} disabled style={{width: 'calc(100% - 100px - 15px)'}} />
                                                                        <div className="formProfilePhoneNumberBoxInputBtn" style={{width: '110px', gap: '10px'}}>
                                                                            <div
                                                                                className="deleteBtn deleteNumberNumber"
                                                                                data-tooltip-id="my-tooltip"
                                                                                data-tooltip-content="Delete Number"
                                                                                onClick={() => handleDeleteNumberClick(index,number.id)} // Adjust index
                                                                            >
                                                                                <RiDeleteBin6Line />
                                                                            </div>
                                                                            <div
                                                                                className="editBtn editNumberNumber"
                                                                                data-tooltip-id="my-tooltip"
                                                                                data-tooltip-content="Edit Number"
                                                                                onClick={() => handleEditNumberClickalter(number.phone_number,number.id)}
                                                                            >
                                                                                <RiEditLine />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </>
                                                        )}

                                                        {/* Add New Phone Number Button */}
                                                        <div className="addMoreBtnArea">
                                                            <div className="addNewBtn" onClick={handleAddNumberClick}>
                                                                Add New Number
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                               
                                                <div className="formProfileColumn">
                                                    <div className="formProfilePhoneNumberBox">
                                                        {/* <label htmlFor="">District</label> */}
                                                        <div className="formProfilePhoneNumberBoxInput fullWidth">
                                                            {/* <input type="text" value={formplaceData.district_val} name="district_val" onChange={handleplaceClick}/> */}
                                                            <CustomSingleSelectDropdown
                                                                options={districtList}
                                                                label="District"
                                                                value={selectedDistrict}
                                                                onChange={handleDistrictChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="formProfilePhoneNumberBox">
                                                        {/*<label htmlFor="">Town</label>*/}
                                                        <div className="formProfilePhoneNumberBoxInput fullWidth">
                                                            {/* <input type="text" value={formplaceData.town_val} name="town_val" onChange={handleplaceClick}/> */}
                                                            <CustomSingleSelectDropdown
                                                                options={townList}
                                                                label="Town"
                                                                onChange={handleTownChange}
                                                                value={selectedTown}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="formProfilePhoneNumberBox">
                                                        <label htmlFor="">Experiance</label>
                                                        <div className="formProfilePhoneNumberBoxInput fullWidth">
                                                            <input type="text" value={formplaceData.experiance_val} name="experiance_val" onChange={handleplaceClick}/>
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                              

                                                <div className="formProfileColumn">
                                                    <div className="formProfileHeadRole">
                                                        <div className="formGroup">
                                                            <label htmlFor="">Role</label>
                                                            <div className="formProfileHeadRoleRadioBtn">
                                                                <div
                                                                    className="formProfileHeadRoleRadioBtnBox"
                                                                    data-tooltip-id="my-tooltip"
                                                                    data-tooltip-content="Switch to User"
                                                                >
                                                                    <input
                                                                        type="radio"
                                                                        name="role"
                                                                        id="user"
                                                                        checked={selectedRole === "user"}
                                                                        onChange={handleRoleChange}
                                                                    />
                                                                    <label htmlFor="user">
                                                                        <div className="icon">
                                                                            <RiUser3Line />
                                                                        </div>
                                                                        <p>User</p>
                                                                    </label>
                                                                </div>
                                                                <div
                                                                    className="formProfileHeadRoleRadioBtnBox"
                                                                    data-tooltip-id="my-tooltip"
                                                                    data-tooltip-content="Switch to Agent"
                                                                >
                                                                    <input
                                                                        type="radio"
                                                                        name="role"
                                                                        id="Agent"
                                                                        checked={selectedRole === "Agent"}
                                                                        onChange={handleRoleChange}
                                                                    />
                                                                    <label htmlFor="Agent">
                                                                        <div className="icon">
                                                                            <RiUserLocationLine />
                                                                        </div>
                                                                        <p>Agent</p>
                                                                    </label>
                                                                </div>
                                                                <div
                                                                    className="formProfileHeadRoleRadioBtnBox"
                                                                    data-tooltip-id="my-tooltip"
                                                                    data-tooltip-content="Switch to Builder"
                                                                >
                                                                    <input
                                                                        type="radio"
                                                                        name="role"
                                                                        id="Builder"
                                                                        checked={selectedRole === "Builder"}
                                                                        onChange={handleRoleChange}
                                                                    />
                                                                    <label htmlFor="Builder">
                                                                        <div className="icon">
                                                                            <GrUserWorker />
                                                                        </div>
                                                                        <p>Builder</p>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="formMainBtnArea">
                                                    <button onClick={updateSubmit}>Update</button>
                                                </div>
                                            </form>
                                        </div>
                                    </Suspense>
                                </TabPanel>
                                <TabPanel>
                                    <Suspense fallback={<div>Loading...</div>}>
                                        <div className="myProfileMyProperties">
                                            <Tabs>
                                                <div className="myProfileMyPropertiesTab">
                                                    <TabList>
                                                        <Tab onClick={() => handleClick(1)}>
                                                            <div className="icon">
                                                                <BsEmojiSmile />
                                                            </div>
                                                            <p>Uploaded Properties</p>
                                                            <div className="propertyColunt">{PendingProperties}</div>
                                                        </Tab>
                                                        <Tab onClick={() => handleClick(2)}>
                                                            <div className="icon">
                                                                <BsEmojiSunglasses />
                                                            </div>
                                                            <p>Sold Properties</p>
                                                            <div className="propertyColunt">{CompletedProperties}</div>
                                                        </Tab>
                                                        <Tab onClick={() => handleClick(1)}>
                                                            <div className="icon">
                                                                <BsEmojiSurprise />
                                                            </div>
                                                            <p>Pending Properties</p>
                                                            <div className="propertyColunt">{PendingProperties}</div>
                                                        </Tab>
                                                        <Tab onClick={() => handleClick(3)}>
                                                            <div className="icon">
                                                                <BsEmojiTear />
                                                            </div>
                                                            <p>Inactive Properties</p>
                                                            <div className="propertyColunt">{inactiveProperties}</div>
                                                        </Tab>
                                                    </TabList>
                                                </div>
                                                <div className="myProfileMyPropertiesTabPanel">
                                                <TabPanel>
                                                <div className="myProfileMyPropertiesList">
                                                    {ispropertyloading ? (
                                                        <div className="SkeletonLoader">
                                                            {[...Array(6)].map((_, index) => (
                                                                <div className="SkeletonLoaderBox" key={index}>
                                                                    <div className="SkeletonLoaderBoxCol1">
                                                                        <Skeleton />
                                                                    </div>
                                                                    <div className="SkeletonLoaderBoxCol2">
                                                                        <Skeleton />
                                                                        <Skeleton />
                                                                        <Skeleton />
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : Array.isArray(myPropertydata) && myPropertydata.length > 0 ? (
                                                        myPropertydata.map((property) => (
                                                            <PropertyBox 
                                                                key={property.propertyId}
                                                                propertyLink={`${path}innerProperty/${property.propertyId}/${property.propertyType.replace('/', '').replace(/\s+/g, '-')}-for-${property.propertyAction}`}
                                                                propertyImage={property.imageName ? `https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/${property.imageName}` : BASE_URL_NOIMG} 
                                                                propertyPurposeTag={property.propertyAction} 
                                                                propertyId={property.propertyId}
                                                                propertyName={`${property.propertyType} For ${property.propertyAction}`} 
                                                                propertyLocation={`${property.district} , ${property.town}`}
                                                                propertyDate={property.addedDate}
                                                                propertyPrice={property.priceVisibility === 'no' ? 'Not disclosed' : property.propertyPricerange} 
                                                                propertyType={property.propertyType}
                                                                propertySeen={false}
                                                                propertyContacted={false}
                                                                onPropertySettingClick={() => setIsSettingPopupVisible(!isSettingPopupVisible)}
                                                                onPropertyIdclick={handlePropertySettingClick}
                                                            />
                                                        ))
                                                    ) : (
                                                        <div className="emptyPage">
                                                            <div className="emptyPageBoxThumbnail">
                                                                <video playsInline preload="auto" autoPlay muted loop>
                                                                    <source src={emptyVideo} type="video/mp4" />
                                                                </video>
                                                            </div>
                                                            <div className="emptyPageBoxDetails">
                                                                <h2 className="title">You haven’t posted any properties yet!</h2>
                                                                <p>Start showcasing your property now to attract potential buyers or tenants effortlessly.</p>
                                                                <Link to="https://esightsolutions.in/postProperty/post-details-info.html?id=0" target="_blank">
                                                                    Post Properties
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </TabPanel>


                                            <TabPanel>
                                            <div className="myProfileMyPropertiesList">
                                                {ispropertyloading ? (
                                                    <div className="SkeletonLoader">
                                                        {[...Array(6)].map((_, index) => (
                                                            <div className="SkeletonLoaderBox" key={index}>
                                                                <div className="SkeletonLoaderBoxCol1">
                                                                    <Skeleton />
                                                                </div>
                                                                <div className="SkeletonLoaderBoxCol2">
                                                                    <Skeleton />
                                                                    <Skeleton />
                                                                    <Skeleton />
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : Array.isArray(myPropertydata) && myPropertydata.length > 0 ? (
                                                    myPropertydata.map((property) => (
                                                        <PropertyBox 
                                                            key={property.propertyId}
                                                            propertyLink={`${path}innerProperty/${property.propertyId}/${property.propertyType.replace('/', '').replace(/\s+/g, '-')}-for-${property.propertyAction}`}
                                                            propertyImage={property.imageName ? `https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/${property.imageName}` : BASE_URL_NOIMG} 
                                                            propertyPurposeTag={property.propertyAction} 
                                                            propertyId={property.propertyId}
                                                            propertyName={`${property.propertyType} For ${property.propertyAction}`} 
                                                            propertyLocation={`${property.district} , ${property.town}`}
                                                            propertyDate={property.addedDate}
                                                            propertyPrice={property.priceVisibility === 'no' ? 'Not disclosed' : property.propertyPricerange} 
                                                            propertyType={property.propertyType}
                                                            propertySeen={false}
                                                            propertyContacted={false}
                                                            onPropertySettingClick={() => setIsSettingPopupVisible(!isSettingPopupVisible)}
                                                            onPropertyIdclick={handlePropertySettingClick}
                                                        />
                                                    ))
                                                ) : (
                                                    <div className="emptyPage">
                                                        <div className="emptyPageBoxThumbnail">
                                                            <video playsInline preload="auto" autoPlay muted loop>
                                                                <source src={emptyVideo} type="video/mp4" />
                                                            </video>
                                                        </div>
                                                        <div className="emptyPageBoxDetails">
                                                            <h2 className="title">You haven’t posted any properties yet!</h2>
                                                            <p>Start showcasing your property now to attract potential buyers or tenants effortlessly.</p>
                                                            <Link to="https://esightsolutions.in/postProperty/post-details-info.html?id=0" target="_blank">
                                                                Post Properties
                                                            </Link>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </TabPanel>


                                        <TabPanel>
                                            <div className="myProfileMyPropertiesList">
                                                {ispropertyloading ? (
                                                    <div className="SkeletonLoader">
                                                        {[...Array(6)].map((_, index) => (
                                                            <div className="SkeletonLoaderBox" key={index}>
                                                                <div className="SkeletonLoaderBoxCol1">
                                                                    <Skeleton />
                                                                </div>
                                                                <div className="SkeletonLoaderBoxCol2">
                                                                    <Skeleton />
                                                                    <Skeleton />
                                                                    <Skeleton />
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : Array.isArray(myPropertydata) && myPropertydata.length > 0 ? (
                                                    myPropertydata.map((property) => (
                                                        <PropertyBox 
                                                            key={property.propertyId}
                                                            propertyLink={`${path}innerProperty/${property.propertyId}/${property.propertyType.replace('/', '').replace(/\s+/g, '-')}-for-${property.propertyAction}`}
                                                            propertyImage={property.imageName ? `https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/${property.imageName}` : BASE_URL_NOIMG} 
                                                            propertyPurposeTag={property.propertyAction} 
                                                            propertyId={property.propertyId}
                                                            propertyName={`${property.propertyType} For ${property.propertyAction}`} 
                                                            propertyLocation={`${property.district} , ${property.town}`}
                                                            propertyDate={property.addedDate}
                                                            propertyPrice={property.priceVisibility === 'no' ? 'Not disclosed' : property.propertyPricerange} 
                                                            propertyType={property.propertyType}
                                                            propertySeen={false}
                                                            propertyContacted={false}
                                                            onPropertySettingClick={() => setIsSettingPopupVisible(!isSettingPopupVisible)}
                                                            onPropertyIdclick={handlePropertySettingClick}
                                                        />
                                                    ))
                                                ) : (
                                                    <div className="emptyPage">
                                                        <div className="emptyPageBoxThumbnail">
                                                            <video playsInline preload="auto" autoPlay muted loop>
                                                                <source src={emptyVideo} type="video/mp4" />
                                                            </video>
                                                        </div>
                                                        <div className="emptyPageBoxDetails">
                                                            <h2 className="title">You haven’t posted any properties yet!</h2>
                                                            <p>Start showcasing your property now to attract potential buyers or tenants effortlessly.</p>
                                                            <Link to="https://esightsolutions.in/postProperty/post-details-info.html?id=0" target="_blank">
                                                                Post Properties
                                                            </Link>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </TabPanel>


                                        <TabPanel>
                                            <div className="myProfileMyPropertiesList">
                                                {ispropertyloading ? (
                                                    <div className="SkeletonLoader">
                                                        {[...Array(6)].map((_, index) => (
                                                            <div className="SkeletonLoaderBox" key={index}>
                                                                <div className="SkeletonLoaderBoxCol1">
                                                                    <Skeleton />
                                                                </div>
                                                                <div className="SkeletonLoaderBoxCol2">
                                                                    <Skeleton />
                                                                    <Skeleton />
                                                                    <Skeleton />
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : Array.isArray(myPropertydata) && myPropertydata.length > 0 ? (
                                                    myPropertydata.map((property) => (
                                                        <PropertyBox 
                                                            key={property.propertyId}
                                                            propertyLink={`${path}innerProperty/${property.propertyId}/${property.propertyType.replace('/', '').replace(/\s+/g, '-')}-for-${property.propertyAction}`}
                                                            propertyImage={property.imageName ? `https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/${property.imageName}` : BASE_URL_NOIMG} 
                                                            propertyPurposeTag={property.propertyAction} 
                                                            propertyId={property.propertyId}
                                                            propertyName={`${property.propertyType} For ${property.propertyAction}`} 
                                                            propertyLocation={`${property.district} , ${property.town}`}
                                                            propertyDate={property.addedDate}
                                                            propertyPrice={property.priceVisibility === 'no' ? 'Not disclosed' : property.propertyPricerange} 
                                                            propertyType={property.propertyType}
                                                            propertySeen={false}
                                                            propertyContacted={false}
                                                            onPropertySettingClick={() => setIsSettingPopupVisible(!isSettingPopupVisible)}
                                                            onPropertyIdclick={handlePropertySettingClick}
                                                        />
                                                    ))
                                                ) : (
                                                    <div className="emptyPage">
                                                        <div className="emptyPageBoxThumbnail">
                                                            <video playsInline preload="auto" autoPlay muted loop>
                                                                <source src={emptyVideo} type="video/mp4" />
                                                            </video>
                                                        </div>
                                                        <div className="emptyPageBoxDetails">
                                                            <h2 className="title">You haven’t posted any properties yet!</h2>
                                                            <p>Start showcasing your property now to attract potential buyers or tenants effortlessly.</p>
                                                            <Link to="https://esightsolutions.in/postProperty/post-details-info.html?id=0" target="_blank">
                                                                Post Properties
                                                            </Link>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </TabPanel>


                                                </div>
                                            </Tabs>
                                        </div>
                                    </Suspense>
                                </TabPanel>

                                <TabPanel>
                                {isLoadingcontacted ? (
                                    <div className='SkeletonLoader4'>
                                    <div className='SkeletonLoaderBox'>
                                        <div className="SkeletonLoaderBoxCol1">
                                        <Skeleton />
                                        </div>
                                    </div>
                                    </div>
                                ) : (
                                    <Suspense fallback={<div>Loading...</div>}>
                                    <div className="myProfileContactedProperty">
                                        {Array.isArray(ContactedPropeties) && ContactedPropeties.length > 0 ? (
                                        ContactedPropeties.map((ContactedPropety) => (
                                            <div key={ContactedPropety.propertyId} className="myProfileContactedPropertyBox">
                                            {ContactedPropety.propertStatus === 0 && (
                                                <div className="myProfileContactedPropertyBoxRemovedBadge">
                                                <h3>This Property Removed from Seller</h3>
                                                </div>
                                            )}
                                            <a 
                                                href={`${path}innerProperty/${ContactedPropety.propertyId}/${ContactedPropety.propertyType.replace('/', '') + " for " + ContactedPropety.propertyAction}`} 
                                                target="_blank" 
                                                rel="noopener noreferrer" 
                                                className="propertyLink">
                                            </a>
                                            <div className="myProfileContactedPropertyBoxThumbnail">
                                                <img 
                                                src={ContactedPropety.imageName 
                                                    ? `https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/${ContactedPropety.imageName}` 
                                                    : BASE_URL} 
                                                alt={ContactedPropety.propertyType} 
                                                />
                                            </div>
                                            <div className="myProfileContactedPropertyBoxDetails">
                                                <div className="propertyName">{ContactedPropety.propertyType}</div>
                                                <div className="propertyLocation">{`${ContactedPropety.district}, ${ContactedPropety.town}`}</div>
                                                <div className="propertyContact">
                                                <p>Last Contacted on: {ContactedPropety.addedDate}</p>
                                                <a href={`tel:+91${ContactedPropety.phone_number}`} className="callButton">Call Now</a>
                                                </div>
                                            </div>
                                            </div>
                                        ))
                                        ) : (
                                        <div className="emptyPage">
                                            <div className="emptyPageBoxThumbnail">
                                            <video playsInline preload="auto" autoPlay muted loop>
                                                <source src={emptyVideo} type="video/mp4" />
                                            </video>
                                            </div>
                                            <div className="emptyPageBoxDetails">
                                            <h2 className="title">You haven’t contacted any person yet!</h2>
                                            </div>
                                        </div>
                                        )}
                                    </div>
                                    </Suspense>
                                )}
                                </TabPanel>

                                <TabPanel>
                                {isLoadingsaved ? (
                                    <div className="SkeletonLoader4">
                                        <div className="SkeletonLoaderBox">
                                            <div className="SkeletonLoaderBoxCol1">
                                                <Skeleton />
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <Suspense fallback={<div>Loading...</div>}>
                                        <div className="myProfileSavedProperty">
                                            {savedP.length > 0 ? (
                                                savedP.map((allsavedP) => (
                                                    <PropertyBox
                                                        key={allsavedP.propertyId}
                                                        propertyLink={`${path}innerProperty/${allsavedP.propertyId}/${allsavedP.propertyType.replace('/', '').replace(/\s+/g, '-') + "-for-" + allsavedP.propertyAction}`}
                                                        propertyImage={allsavedP.imageName ? `https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/${allsavedP.imageName}` : BASE_URL_NOIMG}
                                                        propertyPurposeTag={allsavedP.propertyAction}
                                                        propertyId={allsavedP.propertyId}
                                                        propertyName={`${allsavedP.propertyType} For ${allsavedP.propertyAction}`}
                                                        propertyLocation={`${allsavedP.district}, ${allsavedP.town}`}
                                                        propertyDate={allsavedP.addedDate}
                                                        propertyPrice={allsavedP.priceVisibility === 'no' ? 'Not disclosed' : allsavedP.propertyPricerange}
                                                        propertyType={allsavedP.propertyType}
                                                        propertySeen={false}
                                                        propertyContacted={false}
                                                        savedStatus={1} // Pass the savedStatus
                                                    />
                                                ))
                                            ) : (
                                                <div className="emptyPage">
                                                    <div className="container">
                                                        <div className="emptyPageMain">
                                                            <div className="emptyPageBoxThumbnail">
                                                                <video playsInline preload="auto" autoPlay muted loop>
                                                                    <source src={emptyVideo} type="video/mp4" />
                                                                </video>
                                                            </div>
                                                            <div className="emptyPageBoxDetails">
                                                                <h2 className="title">You haven’t saved anything yet!</h2>
                                                                <p>You currently have no saved items. Start exploring and bookmarking your favorites to easily access them later!</p>
                                                                <Link to={`${path}properties`}>Explore Properties</Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </Suspense>
                                )}

                                </TabPanel>
                                <TabPanel>
                                    <Suspense fallback={<div>Loading...</div>}>
                                        <div className="myProfilePostProjects">
                                            <div className="myProfilePostProjectsHead">
                                                <h2>Post Projects</h2>
                                                <div className="addProjectsBtn" onClick={() => addProjectClick()}>Add Projects</div>
                                            </div>
                                            <div className="myProfilePostProjectsBody">
                                                <div className="myProfilePostProjectsList">
                                                {projects2.map((project) => (
                                                    <div key={project.id} className="builderProjectListBox">
                                                    <a href={`${path}builderProjectPreview/${project.id}`} className="builderProjectListBoxLink"></a>
                                                    <div className="builderProjectListBoxBtnArea">
                                                        <div className="builderProjectListBoxBtn" onClick={() => addProjectClick(project.id)}>
                                                        <RiEditLine />
                                                        </div>
                                                        <div className="builderProjectListBoxBtn" onClick={() => handleDeleteClick(project.id)}>
                                                        <RiDeleteBin7Line />
                                                        </div>
                                                    </div>
                                                    <div className="builderProjectListBoxThumbnail">
                                                        <img src={mediaUrl+project.image} alt="" />
                                                        <div className="builderProjectListBoxTag">{project.project_status}</div>
                                                    </div>
                                                    <div className="builderProjectListBoxDetails">
                                                        <h3>{project.project_name}</h3>
                                                        <p>{project.location_val}</p>
                                                    </div>
                                                    </div>
                                                ))}
                                                </div>
                                                <div className="emptyPage" style={{ display: ChcekPorjects }}>
                                                    <div className="emptyPageMain">
                                                        <div className="emptyPageBoxThumbnail">
                                                            <video
                                                                playsInline
                                                                preload="auto"
                                                                autoPlay
                                                                muted
                                                                loop
                                                            >
                                                                <source src={emptyVideo} type="video/mp4" />
                                                            </video>
                                                        </div>
                                                        <div className="emptyPageBoxDetails">
                                                            <h2 className="title">You are not added any projects yet!</h2>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Suspense>
                                </TabPanel>
                                <TabPanel> 
                                    <Suspense fallback={<div>Loading...</div>}>
                                        <div className="myProfileCreateTemplate">
                                            {previewMode ? (
                                                <div className="preview">
                                                    <div className="previewNav">
                                                        <div className="navMain">
                                                            <div className="navCol1">
                                                                <div className="navLogo">
                                                                    {logoImages.map((src, index) => (
                                                                        <img key={index} src={src} alt={`Logo ${index}`} className="logo-image" />
                                                                    ))}
                                                                </div>
                                                            </div>
                                                            <div className="navCol2">
                                                                <div className="navLink">
                                                                    <ul>
                                                                        <li>
                                                                            <div className="previewNavLink">Home</div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="previewNavLink">Projects</div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="previewNavLink">Properties</div>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                            <div className="navCol3">
                                                                <div className="navProfile">
                                                                    <div className="navPostproperty">Kerala Plots <FiArrowUpRight /></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <section className="banner">
                                                    <div className="carouselWrapper">

                                                        {/* Carousel */}
                                                        <OwlCarousel {...settings1} ref={carouselRef}>
                                                        {bannerImages.map((image, index) => (
                                                            <div className="bannerBox" key={index}>
                                                                <img src={image.url} alt={`Banner ${index}`} className="banner-image" />
                                                            </div>
                                                        ))}
                                                    </OwlCarousel>
                                                </div>

                                                    </section>
                                                    <section className="about">
                                                        <h3>{about.title}</h3>
                                                        <p>{about.description}</p>
                                                    </section>
                                                    <section className="projects">
                                                        <div className="innerBuildersProjectsHead">
                                                            <h2 className="title">Featured Projects</h2>
                                                        </div>
                                                        <div className="projectsList">
                                                            {WebsiteProjectdeatils
                                                            .filter((project) => project.checked)
                                                            .map((project) => (
                                                                <div key={project.id} className="projectsBox">
                                                                    <div className="projectsBoxThumbnail">
                                                                        <img src={mediaUrl+project.image} alt={project.project_name} />
                                                                        <div className="innerBuildersProjectsBoxTag">{project.project_status}</div>
                                                                    </div>
                                                                    <div className="projectsBoxDetails">
                                                                        <h4>{project.project_name}</h4>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </section>
                                                    <section className="properties">
                                                        <div className="innerBuildersPropertyHead">
                                                            <h2 className="title">Explore Properties</h2>
                                                        </div>
                                                        <div className="propertyList">
                                                            {properties
                                                            .filter((property) => property.checked)
                                                            .map((property) => (
                                                                <div key={property.propertyId} className="propertyBox">
                                                                    <div className="propertyBoxThumbnail">
                                                                        <img src={property.imageName ? "https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/"+property.imageName : BASE_URL_NOIMG}
                                                                        alt={property.propertyType} />
                                                                    </div>
                                                                    <div className="propertyBoxDetails">
                                                                        <h4>{property.propertyType}</h4>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </section>
                                                    <section className="testimonials">
                                                        <div className="innerBuildersTestimonialsHead">
                                                            <h2 className="title">What our clients say</h2>
                                                        </div>
                                                        <div className="testimonialsList">
                                                            <div className="carouselWrapper">
                                                                {/* Custom Prev Button */}
                                                                <button className="customNavBtn prev" onClick={() => goToPrev(carouselRef)}>
                                                                    <GoChevronLeft />
                                                                </button>

                                                                {/* Carousel */}
                                                                <OwlCarousel {...settings} ref={carouselRef}>
                                                                    {testimonials.map((testimonial, index) => (
                                                                        <Suspense>
                                                                            <div className="innerBuildersTestimonialsBox" key={index}>
                                                                                <div className="iconLeft">
                                                                                    <FaQuoteLeft />
                                                                                </div>
                                                                                {/* <p>{testimonial.message}</p> */}
                                                                                <p 
                                                                                    ref={(el) => (textRefs.current[index] = el)}
                                                                                    className={expandedIndex === index ? "expandedText" : "collapsedText"}
                                                                                >
                                                                                    {testimonial.message}
                                                                                </p>
                                                                                {/* {expandable[index] && ( */}
                                                                                    <button className="toggleButton" onClick={() => toggleExpand(index)}>
                                                                                        {expandedIndex === index ? "Shrink" : "Expand"}
                                                                                    </button>
                                                                                {/* )} */}
                                                                                <div className="iconRight">
                                                                                    <FaQuoteRight />
                                                                                </div>
                                                                                <div className="innerBuildersTestimonialsBoxProfile">
                                                                                    <div className="innerBuildersTestimonialsBoxProfileImg">
                                                                                        <RiUser4Line />
                                                                                    </div>
                                                                                    <h3>{testimonial.name}</h3>
                                                                                </div>
                                                                            </div>
                                                                        </Suspense>
                                                                    ))}
                                                                </OwlCarousel>

                                                                {/* Custom Next Button */}
                                                                <button className="customNavBtn next" onClick={() => goToNext(carouselRef)}>
                                                                    <GoChevronRight />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </section>
                                                    <section className="gallery">
                                                        <div className="gallery-grid">
                                                        {galleryImages.map((image, index) => (
                                                            <img key={index} src={image.url} alt={`Gallery ${index}`} className="gallery-image" />
                                                        ))}
                                                        </div>
                                                    </section>
                                                    <section className="contact">
                                                        <div className="footerMain">
                                                            <div className="footerBox1">
                                                                <div className="footerLogo">
                                                                    {logoImages.map((src, index) => (
                                                                        <img key={index} src={src} alt={`Logo ${index}`} className="logo-image" />
                                                                    ))}
                                                                </div>
                                                                <div className='footerSocialLink'>
                                                                    <Link target="_blank" to={contact.facebook} className='footerSocialLinkBox'>
                                                                        <BiLogoFacebook />
                                                                    </Link>
                                                                    <Link target="_blank" to={contact.instagram} className='footerSocialLinkBox'>
                                                                        <PiInstagramLogoFill />
                                                                    </Link>
                                                                    <Link target="_blank" to={contact.linkedin} className='footerSocialLinkBox'>
                                                                        <RiLinkedinFill />
                                                                    </Link>
                                                                    <Link target="_blank" to={contact.youtube} className='footerSocialLinkBox'>
                                                                        <PiYoutubeLogoFill />
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                            <div className="footerBox2">
                                                                <h2>Links</h2>
                                                                <ul>
                                                                    <li>
                                                                        <Link><span></span>Home</Link>
                                                                    </li>
                                                                    <li>
                                                                        <Link><span></span>Projects</Link>
                                                                    </li>
                                                                    <li>
                                                                        <Link><span></span>Properties</Link>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            <div className="footerBox3">
                                                                <h2>Connect Us</h2>
                                                                <ul>
                                                                    <li>
                                                                        <div className='icon'>
                                                                            <PiPhoneCall />
                                                                        </div>
                                                                        <div className='contactDestails'>
                                                                            <p>{contact.phone1}</p>
                                                                            <p>{contact.phone2 === 0 ? '' : contact.phone2}</p>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <div className='icon'>
                                                                            <MdAlternateEmail />
                                                                        </div>
                                                                        <div className='contactDestails'>
                                                                            <p>{contact.email}</p>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <div className='icon'>
                                                                            <GrLocation />
                                                                        </div>
                                                                        <div className='contactDestails'>
                                                                            <p>{contact.address1} <br/>{contact.address2} <br/>{contact.address3}</p>
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </section>
                                                    </div>
                                                ) : (
                                                <div className="editor" >
                                                    <section className={`editorBox logo-editor ${activeIndices.includes(0) ? "active" : ""}`}>
                                                        <div className="editorBoxHead" onClick={() => toggleEditorBox(0)}>
                                                            <h3>Logo</h3>
                                                            <div className="editorBoxHeadExpandBtn">
                                                                {activeIndices.includes(0) ? <MdRemove /> : <MdAdd />}
                                                            </div>
                                                        </div>
                                                        <div className="editorBoxBody" style={{ maxHeight: activeIndices.includes(0) ? "100%" : "0" }}>
                                                            <div className="editorBoxBodyMain">
                                                                <div className="editorBoxForm">
                                                                    <div className="editorBoxFormBox">
                                                                        <input
                                                                            type="text"
                                                                            placeholder="Company Name"
                                                                            name="name"
                                                                            value={companyName}
                                                                            onChange={handleCompanyNameChange}
                                                                            maxLength={30}
                                                                        />
                                                                        <div className="inputTextCount">{0 + companyName.length} / 30</div>
                                                                        {companyerror.name && (
                                                                        <span className="error-message">{companyerror.name}</span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className="logo-dropzone"
                                                                    onDragOver={(e) => e.preventDefault()}
                                                                    onDrop={handleLogoDrop}
                                                                    style={{marginTop: '30px'}}
                                                                    >
                                                                    <label className="custom-file-upload">
                                                                        <input
                                                                            type="file"
                                                                            accept="image/*"
                                                                            onChange={(e) => handleLogoUpload(Array.from(e.target.files))}
                                                                        />
                                                                        <div className="uploadIcon">
                                                                            <AiOutlineCloudUpload />
                                                                        </div>
                                                                        <p>Upload logo Image</p>
                                                                    </label>
                                                                </div>
                                                                
                                                                <div className="logo-preview">
                                                                    {logoImages.map((src, index) => (
                                                                        <div key={index} className="logo-item">
                                                                            <img src={src} alt={`logo ${index}`} className="logo-preview-image" />
                                                                            <button className="logoImageDeleteBtn" onClick={() => removeLogoImage(index)}><RiDeleteBin7Line /></button>
                                                                        </div>
                                                                    ))}
                                                                   {websitelogosectionError && <span className="error-message">{websitelogosectionError}</span>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </section>
                                                    {websitelogocompError && <span className="error-message">{websitelogocompError}</span>}
                                                    <section className={`editorBox banner-editor ${activeIndices.includes(1) ? "active" : ""}`}>
                                                        <div className="editorBoxHead" onClick={() => toggleEditorBox(1)}>
                                                            <h3>Banner</h3>
                                                            <div className="editorBoxHeadExpandBtn">
                                                                {activeIndices.includes(1) ? <MdRemove /> : <MdAdd />}
                                                            </div>
                                                        </div>
                                                        <div className="editorBoxBody" style={{ maxHeight: activeIndices.includes(1) ? "100%" : "0" }}>
                                                            <div className="editorBoxBodyMain">
                                                                <div
                                                                    className="banner-dropzone"
                                                                    onDragOver={(e) => e.preventDefault()}
                                                                    onDrop={handleBannerDrop}
                                                                    >
                                                                    <label className="custom-file-upload">
                                                                        <input
                                                                            type="file"
                                                                            multiple
                                                                            accept="image/*"
                                                                            onChange={(e) => handleBannerUpload(Array.from(e.target.files))}
                                                                        />
                                                                        <div className="uploadIcon">
                                                                            <AiOutlineCloudUpload />
                                                                        </div>
                                                                        <p>Upload Banner Images</p>
                                                                    </label>
                                                                </div>
                                                                <div className="banner-preview">
                                                                    {bannerImages.map((image, index) => (
                                                                        <div key={index} className="banner-item">
                                                                            <img src={image.url} alt={`Banner ${index}`} className="banner-preview-image" />
                                                                            <button className="bannerImageDeleteBtn" onClick={() => removeBannerImage(index,image.id)}>
                                                                                <RiDeleteBin7Line />
                                                                            </button>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </section>
                                                    {websitebannererr && <span className="error-message">{websitebannererr}</span>}
                                                    <section className={`editorBox about-editor ${activeIndices.includes(2) ? "active" : ""}`}>
                                                        <div className="editorBoxHead" onClick={() => toggleEditorBox(2)}>
                                                            <h3>About</h3>
                                                            <div className="editorBoxHeadExpandBtn">
                                                                {activeIndices.includes(2) ? <MdRemove /> : <MdAdd />}
                                                            </div>
                                                        </div>
                                                        <div className="editorBoxBody" style={{ maxHeight: activeIndices.includes(2) ? "100%" : "0" }}>
                                                            <div className="editorBoxBodyMain">
                                                            <div className="editorBoxForm">
                                                                <div className="editorBoxFormBox">
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Title"
                                                                        name="title"
                                                                        value={about.title}
                                                                        maxLength={35}
                                                                        onChange={handleAboutChange}
                                                                    />
                                                                    <div className="inputTextCount">{about.title.length} / 35</div>
                                                                    {webeaboutrrors.title && <span className="error-message">{webeaboutrrors.title}</span>}
                                                                </div>
                                                                <div className="editorBoxFormBox">
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Experience"
                                                                        name="experience"
                                                                        value={about.experience}
                                                                        maxLength={3}
                                                                        onChange={handleAboutChange}
                                                                    />
                                                                    <div className="inputTextCount">{about.experience.length} / 3</div>
                                                                    {webeaboutrrors.experience && <span className="error-message">{webeaboutrrors.experience}</span>}
                                                                </div>
                                                                <div className="editorBoxFormBoxTeaxtarea">
                                                                    <textarea
                                                                        placeholder="Description"
                                                                        name="description"
                                                                        value={about.description}
                                                                        maxLength={300}
                                                                        onChange={handleAboutChange}
                                                                    ></textarea>
                                                                    <div className="inputTextCount">{about.description.length} / 300</div>
                                                                    {webeaboutrrors.description && <span className="error-message">{webeaboutrrors.description}</span>}
                                                                </div>
                                                            </div>

                                                            </div>
                                                        </div>
                                                    </section>
                                                    {websectioneaboutrrors && <span className="error-message">{websectioneaboutrrors}</span>}
                                                    <section className={`editorBox projects-editor ${activeIndices.includes(3) ? "active" : ""}`}>
                                                        <div className="editorBoxHead" onClick={() => toggleEditorBox(3)}>
                                                            <h3>Projects</h3>
                                                            <div className="editorBoxHeadExpandBtn">
                                                                {activeIndices.includes(3) ? <MdRemove /> : <MdAdd />}
                                                            </div>
                                                        </div>
                                                        <div className="editorBoxBody" style={{ maxHeight: activeIndices.includes(3) ? "100%" : "0" }}>
                                                            <div className="editorBoxBodyMain">
                                                                <div className="projectsList">
                                                                    {WebsiteProjectdeatils.map((project) => (
                                                                        <div key={project.id} className="projectsBox">
                                                                            <input
                                                                            type="checkbox"
                                                                            id={`project${project.id}`}
                                                                            checked={project.checked}
                                                                            onChange={() => handleProjectCheck(project.id)}
                                                                            />
                                                                            <label htmlFor={`project${project.id}`}>
                                                                            <div className="projectsBoxIcon"></div>
                                                                            <div className="projectsBoxThumbnail">
                                                                                <img src={mediaUrl+project.image} alt={project.project_name} />
                                                                            </div>
                                                                            <div className="projectsBoxDetails">
                                                                                <h4>{project.project_name}</h4>
                                                                            </div>
                                                                            </label>
                                                                        </div>
                                                                    ))}
                                                                    
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </section>
                                                    <section className={`editorBox property-editor ${activeIndices.includes(4) ? "active" : ""}`}>
                                                        <div className="editorBoxHead" onClick={() => toggleEditorBox(4)}>
                                                            <h3>Properties</h3>
                                                            <div className="editorBoxHeadExpandBtn">
                                                                {activeIndices.includes(4) ? <MdRemove /> : <MdAdd />}
                                                            </div>
                                                        </div>
                                                        <div className="editorBoxBody" style={{ maxHeight: activeIndices.includes(4) ? "100%" : "0" }}>
                                                            <div className="editorBoxBodyMain">
                                                                <div className="propertyList">
                                                                    {properties.map((property) => (
                                                                        <div key={property.propertyId} className="propertyBox">
                                                                            <input
                                                                            type="checkbox"
                                                                            id={`property${property.propertyId}`}
                                                                            checked={property.checked}
                                                                            onChange={() => handlePropertyCheck(property.propertyId)}
                                                                            />
                                                                            <label htmlFor={`property${property.propertyId}`}>
                                                                            <div className="propertyBoxIcon"></div>
                                                                            <div className="propertyBoxThumbnail">
                                                                            <img src={property.imageName ? "https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/"+property.imageName : BASE_URL_NOIMG}
                                                                        alt={property.propertyType} />
                                                                            </div>
                                                                            <div className="propertyBoxDetails">
                                                                                <h4>{property.propertyType}</h4>
                                                                            </div>
                                                                            </label>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </section>
                                                    <section className={`editorBox testimonials-editor ${activeIndices.includes(5) ? "active" : ""}`}>
                                                        <div className="editorBoxHead" onClick={() => toggleEditorBox(5)}>
                                                            <h3>Testimonials</h3>
                                                            <div className="editorBoxHeadExpandBtn">
                                                                {activeIndices.includes(5) ? <MdRemove /> : <MdAdd />}
                                                            </div>
                                                        </div>
                                                        <div className="editorBoxBody" style={{ maxHeight: activeIndices.includes(5) ? "100%" : "0" }}>
                                                            <div className="editorBoxBodyMain">
                                                                {testimonials.map((testimonial, index) => (
                                                                <div className="editorBoxForm" key={index}>
                                                                    <div className="editorBoxFormRemoverBtnArea">
                                                                        <button className="deleteTestimonialBtn" onClick={() => removeTestimonial(index,testimonial.id)}>
                                                                            <RiDeleteBin7Line />
                                                                        </button>
                                                                    </div>
                                                                    <div className="editorBoxFormBoxTeaxtarea">
                                                                        <textarea
                                                                        placeholder="Message"
                                                                        value={testimonial.message}
                                                                        maxLength={300}
                                                                        onChange={(e) => handleTestimonialChange(index, 'message', e.target.value)}
                                                                        ></textarea>
                                                                        <div className="inputTextCount">{0 + testimonial.message.length} / 300</div>
                                                                    </div>
                                                                    <div className="editorBoxFormBox">
                                                                        <input
                                                                        type="text"
                                                                        placeholder="Name"
                                                                        value={testimonial.name}
                                                                        maxLength={20}
                                                                        onChange={(e) => handleTestimonialChange(index, 'name', e.target.value)}
                                                                        />
                                                                        <div className="inputTextCount">{0 + testimonial.name.length} / 20</div>
                                                                    </div>
                                                                </div>
                                                                ))}

                                                                {testimonialerror && <span className="error-message">{testimonialerror}</span>}
                                                                <div className="editorBoxFormAddBtnArea">
                                                                    <button className="addTestimonialBtn" onClick={handleAddTestimonial}>Add Testimonial</button>
                                                                </div>
                                                                
                                                            </div>
                                                        </div>
                                                    </section>
                                                    <section className={`editorBox gallery-editor ${activeIndices.includes(6) ? "active" : ""}`}>
                                                        <div className="editorBoxHead" onClick={() => toggleEditorBox(6)}>
                                                            <h3>Gallery</h3>
                                                            <div className="editorBoxHeadExpandBtn">
                                                                {activeIndices.includes(6) ? <MdRemove /> : <MdAdd />}
                                                            </div>
                                                        </div>
                                                        <div className="editorBoxBody" style={{ maxHeight: activeIndices.includes(6) ? "100%" : "0" }}>
                                                            <div className="editorBoxBodyMain">
                                                                <div
                                                                    className="gallery-dropzone"
                                                                    onDragOver={(e) => e.preventDefault()}
                                                                    onDrop={handleGalleryDrop}
                                                                    >
                                                                    <label className="custom-file-upload">
                                                                        <input
                                                                            type="file"
                                                                            multiple
                                                                            accept="image/*"
                                                                            onChange={(e) => handleGalleryUpload(Array.from(e.target.files))}
                                                                        />
                                                                        <div className="uploadIcon">
                                                                            <AiOutlineCloudUpload />
                                                                        </div>
                                                                        <p>Upload Gallery Images</p>
                                                                </label>
                                                                </div>
                                                                <div className="gallery-preview">
                                                                    {galleryImages.map((image, index) => (
                                                                        <div key={index} className="gallery-item">
                                                                            <img src={image.url} alt={`Gallery ${index}`} className="gallery-preview-image" />
                                                                            <button className="galleryImageDeleteBtn" onClick={() => removeGalleryImage(index,image.id)}>
                                                                                <RiDeleteBin7Line />
                                                                            </button>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </section>
                                                    <section className={`editorBox contact-editor ${activeIndices.includes(7) ? "active" : ""}`}>
                                                        <div className="editorBoxHead" onClick={() => toggleEditorBox(7)}>
                                                            <h3>Contact</h3>
                                                            <div className="editorBoxHeadExpandBtn">
                                                                {activeIndices.includes(7) ? <MdRemove /> : <MdAdd />}
                                                            </div>
                                                        </div>
                                                        <div className="editorBoxBody" style={{ maxHeight: activeIndices.includes(7) ? "100%" : "0" }}>
                                                            <div className="editorBoxBodyMain">
                                                                <div className="editorBoxForm">
                                                                    <div className="editorBoxFormBox">
                                                                        <input
                                                                            type="text"
                                                                            name="phone1" // Add name attribute
                                                                            placeholder="Phone 1"
                                                                            value={contact.phone1}
                                                                            onChange={handleContactChange}
                                                                        />
                                                                        {webcontactErrors.phone1 && <span className="error-message">{webcontactErrors.phone1}</span>}
                                                                    </div>
                                                                    <div className="editorBoxFormBox">
                                                                        <input
                                                                            type="text"
                                                                            name="phone2" // Add name attribute
                                                                            placeholder="Phone 2 (Optional)"
                                                                            value={contact.phone2 === 0 ? '' : contact.phone2}
                                                                            onChange={handleContactChange}
                                                                        />
                                                                    </div>
                                                                    <div className="editorBoxFormBox">
                                                                        <input
                                                                            type="email"
                                                                            name="email" // Add name attribute
                                                                            placeholder="Email"
                                                                            value={contact.email}
                                                                            onChange={handleContactChange}
                                                                        />
                                                                        {webcontactErrors.email && <span className="error-message">{webcontactErrors.email}</span>}
                                                                    </div>
                                                                    <br />
                                                                    <div className="editorBoxFormBox">
                                                                        <input
                                                                            type="text"
                                                                            name="address1" // Add name attribute
                                                                            placeholder="Address Line 1"
                                                                            value={contact.address1}
                                                                            onChange={handleContactChange}
                                                                        />
                                                                        {webcontactErrors.address1 && <span className="error-message">{webcontactErrors.address1}</span>}
                                                                    </div>
                                                                    <div className="editorBoxFormBox">
                                                                        <input
                                                                            type="text"
                                                                            name="address2" // Add name attribute
                                                                            placeholder="Address Line 2"
                                                                            value={contact.address2}
                                                                            onChange={handleContactChange}
                                                                        />
                                                                        {webcontactErrors.address2 && <span className="error-message">{webcontactErrors.address2}</span>}
                                                                    </div>
                                                                    <div className="editorBoxFormBox">
                                                                        <input
                                                                            type="text"
                                                                            name="address3" // Add name attribute
                                                                            placeholder="Address Line 3"
                                                                            value={contact.address3}
                                                                            onChange={handleContactChange}
                                                                        />
                                                                        {webcontactErrors.address3 && <span className="error-message">{webcontactErrors.address3}</span>}
                                                                    </div>
                                                                    <br />
                                                                    <div className="editorBoxFormBox">
                                                                        <input
                                                                            type="text"
                                                                            name="facebook" // Add name attribute
                                                                            placeholder="Facebook"
                                                                            value={contact.facebook}
                                                                            onChange={handleContactChange}
                                                                        />
                                                                    </div>
                                                                    <div className="editorBoxFormBox">
                                                                        <input
                                                                            type="text"
                                                                            name="instagram" // Add name attribute
                                                                            placeholder="Instagram"
                                                                            value={contact.instagram}
                                                                            onChange={handleContactChange}
                                                                        />
                                                                    </div>
                                                                    <div className="editorBoxFormBox">
                                                                        <input
                                                                            type="text"
                                                                            name="linkedin" // Add name attribute
                                                                            placeholder="LinkedIn"
                                                                            value={contact.linkedin}
                                                                            onChange={handleContactChange}
                                                                        />
                                                                    </div>
                                                                    <div className="editorBoxFormBox">
                                                                        <input
                                                                            type="text"
                                                                            name="youtube" // Add name attribute
                                                                            placeholder="Youtube"
                                                                            value={contact.youtube}
                                                                            onChange={handleContactChange}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </section>

                                                    {webcontactsecErrors && <span className="error-message">{webcontactsecErrors}</span>}
                                                </div>
                                            )}
                                            <div className="myProfileCreateTemplateBtnArea">
                                                <button 
                                                    className="editPreviewBtn" 
                                                    onClick={() => {
                                                        setPreviewMode((prevMode) => {
                                                        const newMode = !prevMode;
                                                        if (!prevMode) {
                                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                                        }
                                                        return newMode;
                                                        });
                                                    }}>
                                                    {previewMode ? 'Edit' : 'Preview'}
                                                </button>
                                                <button className="submitWebsite" disabled={isDisableweb} onClick={submitWebsite}>{buttonTextweb}</button>
                                            </div>
                                        </div>
                                    </Suspense>
                                </TabPanel>
                            </div>
                        </div>
                    </div>
                </section>
            </Tabs>
        </>
    );
}

export default MyProfile;
